define('viewmodels/VisualAnalytics/QualitativeSetup',['knockout', 'plugins/router', 'services/navigation', 'services/logger', 'durandal/app', 'durandal/system', 'services/appsecurity', 'viewmodels/GeneralSettings', 'services/utils', 'viewmodels/configuration/InherentSetup']
    , function (ko, router, navigation, logger, app, system, appsecurity, ObjGeneralSettings, utils, InherentSetup) {

    var AMLQsViewModel = {
        attached: attached,
        detached: detached,
        activate: activate,
        utils: utils,
        InherentSetup: InherentSetup,
        addResponseType: addResponseType,
        updateResponseItem: updateResponseItem,
        deleteResponseItem: deleteResponseItem,
        deleteResponseButton: deleteResponseButton,
        setTriggerAttach: true,
        appsecurity: appsecurity,
        AssessmentType: ko.observable(),
        CurrentPageNumber: ko.observable(),
        addPopUpCss: ko.observable(true),
        editPopUpCss: ko.observable(true),
        popUpTitle: ko.observable(),
        RiskAreaQType: ko.observable("QUAL"),
        RiskAreaDropDownList: ko.observableArray(),
        SelectedRiskAreaDetails: ko.observableArray(),
        CurrentRiskAreaId: ko.observable(),
        CurrentSubRiskAreaId: ko.observable(),
        CurrentRiskAreaType: ko.observable(),
        UpFunctionalityRiskQuestion: UpFunctionalityRiskQuestion,
        DownFunctionalityRiskQuestion: DownFunctionalityRiskQuestion,
        DownFunctionalityRiskArea: DownFunctionalityRiskArea,
        DownFunctionalityRiskSubArea: DownFunctionalityRiskSubArea,
        SaveQuestionSortOrder: SaveQuestionSortOrder,
        RiskAreaSortOrder: ko.observable(),
        RiskSubAreaSortOrder: ko.observable(),
        RiskQuestionSortOrder: ko.observable(),
        newResponseTypeName: ko.observable(),
        newResponseTypeDescription: ko.observable(),
        newResponseTypeWeights: ko.observable(),
        OpenRiskAreaOrderPopup: OpenRiskAreaOrderPopup,
        OpenQualRespSetupPopup: OpenQualRespSetupPopup,
        OpenRiskQuestionOrderPopup: OpenRiskQuestionOrderPopup,
        ControlsAccess: ko.observable(false),
        RiskAreaQuestionReorderList: ko.observableArray(),
        RiskAreaQuestionReorderListDup: ko.observableArray(),
        RiskAreaReorderList: ko.observableArray(),
        RiskSubAreaReorderList: ko.observableArray(),
        ResponseTypeList: ko.observableArray([]),
        RiskAreaReorderListDup: ko.observableArray(),
        RiskSubAreaReorderListDup: ko.observableArray(),
        CancelResponseItem: CancelResponseItem,
        IsDeletedFlag: ko.observable(),
        CancelRiskAreaQuestionSortOrder: CancelRiskAreaQuestionSortOrder,
        SelectedAssessmentType: ko.observableArray([]),
        SelectedAssessmentTypeSubArea: ko.observableArray([]),
        SelectedAssessmentTypeSubAreaEdit: ko.observableArray([]),
        FactorAssessmentTypeList: ko.observable(),
        FactorAssessmentTypeListEdit: ko.observable(),
        SelectedAssessmentTypeFactor: ko.observable(),
        SelectedAssessmentTypeFactorEdit: ko.observable(),
        SelectedResponseTypeFactor: ko.observable(),
        SelectedCopyOverAreas: ko.observable(),
        SelectedCopyOverAreasEdit: ko.observable(),
        RiskTypeClick: RiskTypeClick,
        RiskAreaTypeList: ko.observableArray([]),
        QualitativeType: ko.observable(),
        AssessmentTypeFactor: ko.observable(),
        QualitativeTypeName: ko.observable('Qualitative Risk Factors'),
        QuestionsList: ko.observableArray(),
        EditQuestionPopUp: EditQuestionPopUp,
        DeleteQuestionPopUp: DeleteQuestionPopUp,
        SaveQuestionPopUpBtn: SaveQuestionPopUpBtn,
        QuestionPopUpData: ko.observable(),
        QuestionPopUpTitle: ko.observable(),
        QuestionPopUpType: ko.observable(),
        RowExpandClick: RowExpandClick,
        resetRadioButtons: resetRadioButtons,
        IRLMasterList: ko.observableArray(),
        QuestionResponsesList: ko.observableArray(),
        AddResponsePopUp: AddResponsePopUp,
        CurrentRiskQuestionType: ko.observable(),
        CurrentRiskQuestionResponseType: ko.observable(),
        EditResponsePopUp: EditResponsePopUp,
        DeleteResponsePopUp: DeleteResponsePopUp,
        SaveResponsePopUpBtn: SaveResponsePopUpBtn,
        ResponsePopUpData: ko.observable(),
        ResponsePopUpTitle: ko.observable(),
        ResponsePopUpType: ko.observable(),
        CalculationCheckboxdisabled: ko.observable(),
        MultiselectQuestionCheckboxdisabled: ko.observable(),
        AssessmentTypeFactorDisabled: ko.observable(true),
        AssessmentTypeAreaDisabled: ko.observable(false),
        AssessmentTypeSubAreaDisabled: ko.observable(false),
        AMLScoreVisible: ko.observable(false),
        SANCScoreVisible: ko.observable(false),
        valueAML: ko.observable(),
        valueSANC: ko.observable(),
        CurrentScreenName: ko.observable('QLDR'),
        AssessmentTypeList: ko.observableArray([]),
        EditAreaVisible: ko.observable(false),
        EditSubAreaVisible: ko.observable(false),
        EditFactorVisible: ko.observable(false),
        SubFactorAssessmentTypeList: ko.observableArray([]),
        SubFactorResponseTypeList: ko.observableArray([]),
        ActionChanged: ActionChanged,
        SelectedAssessmentTypeSubFactor: ko.observableArray([]),
        SelectedAssessmentTypeSubFactorEdit: ko.observableArray([]),
        SelectedResponseTypeSubFactor: ko.observableArray([]),
        SelectedResponseRow: ko.observableArray([]),
        EditQuestion: ko.observable(false),
        LanguageddFactorVisible: ko.observable(true),
        SelectedLanguageFactorType: ko.observableArray([]),
        SelectedLanguageSubFactorType: ko.observableArray([]),
        LanguageList: ko.observableArray(),
        LanguageFactorAdded: LanguageFactorAdded,
        ObjGeneralSettings: ObjGeneralSettings,
        RiskAreaSubList: ko.observableArray(),//factor
        LanguageQualAreaDropdownVisible: ko.observable(true),
        LanguageQualSubAreaDropdownVisible: ko.observable(true),
        SelectedLanguageQualAreaType: ko.observableArray([]),
        SelectedLanguageQualSubAreaType: ko.observableArray([]),
        QualSubAreaLanguageAdded: QualSubAreaLanguageAdded,
        QualAreaLanguageAdded: QualAreaLanguageAdded,
        QualRiskAreaSubList: ko.observableArray(),
        QualRiskSubAreaSubList: ko.observableArray(),
        QualQuestionRiskSubAreaSubList: ko.observableArray(),
        SubFactorRiskAreaList: ko.observableArray(),//sub factor
        InherentRiskLevelList: ko.observableArray([]),
        InherentRiskLevelListDup: ko.observableArray([]),
        QuestionTypeChangedFactor: QuestionTypeChangedFactor,
        FactorReadOnlyType: ko.observable(false),
        FactorHeaderType: ko.observable(false),
        FactorConditionalType: ko.observable(false),
        ParentFactorList: ko.observableArray(),
        ParentFactorResponseList: ko.observableArray([]),
        ParentQuestionChanged: ParentQuestionChanged,
        ParentQuestionId: ko.observable(),
        ParentResponseId: ko.observable(),
        selectedparentResponseId: ko.observableArray([]),
        RiskAreaName: ko.observable(),
        UploadFileSize: ko.observable(1073741824),
        ClickedRiskAreaDetails: ko.observable(),
        ClickedSubRiskAreaDetails: ko.observable(),
        AssessmentTypeListSubArea: ko.observableArray([]),
        AssessmentTypeListModifiedSubArea: ko.observableArray([]),
        RiskSubAreaPopUpType: ko.observable(),
        RiskSubAreaList: ko.observableArray(),
        ClickedAssessmentType: ko.observable(),
        RiskAreaListAsPerAssessmentType: ko.observableArray(),
        GetAllAreaType: GetAllAreaType,
        SelectedAreaType: ko.observable(),
        uploadDownloadDetails: ko.observable(),
        ApplicabilityRelEvents: ApplicabilityRelEvents,
        CopyOverEventClick: CopyOverEventClick,
        InherentSetupQualObj: ko.observableArray([]),
        ZATRATList: ko.observableArray([]),
        ZATRATListDup: ko.observableArray([]),
        ZATRATListLength: ko.observable(),
        ZATDropDownList: ko.observableArray([]),
        ZATDropDownListSubArea: ko.observableArray([]),
        ZATListSubArea: ko.observableArray([]),
        SelectedZATDropDownList: ko.observableArray([]),
        SelectedZATRATList: ko.observableArray([]),
        SelectedAssessmentTypeEdit: ko.observableArray([]),
        SelectedZATDropDownListEdit: ko.observableArray([]),
        SelectedZATDropDownListSubArea: ko.observableArray([]),
        SelectedZATDropDownListSubAreaEdit: ko.observableArray([]),
        AssessmentTypeListModified: ko.observableArray([]),
        ZATDropDownListModified: ko.observableArray([]),
        HeaderFactorsList: ko.observableArray([]),
        HeaderFactorsDropDownList: ko.observableArray([]),
        RiskSubAreasListforZAT: ko.observableArray([]),
        AddAreaFlag: ko.observable(),
        AreaLeveljstree: ko.observable(),
        SelectedAreaName: ko.observable(),
        ToggleNavigationMenu1: ToggleNavigationMenu1,
        ToggleNavigationMenu2: ToggleNavigationMenu2,
        CollapseAllTreeView: CollapseAllTreeView,
        ExpandAllTreeView: ExpandAllTreeView,
        QuestionGuideline: ko.observable(),
        BreadCrumbArray: ko.observableArray([]),
        ConfigureInstructions: ConfigureInstructions,
        SaveInstructions: SaveInstructions,
        Instructions: ko.observable(),
        GetAllOptionsType: GetAllOptionsType,
        OptionsTypeList: ko.observableArray([]),
        //selectedOptionType: ko.observable(),
        ResponseOptionList: ko.observableArray([]),
        changedResponseType: changedResponseType,
        copyOverResponse: ko.observable(false),
        hasChildNodes: ko.observable(false),
        SelectedScenarioId: ko.observable(),

        LocaleCheckFlag: ko.observable(false),
        CloseModel: CloseModel
    };
    return AMLQsViewModel;

    var QuestionTableObj = false;
    var ResponseTableObj = false;
    var addNewResponseType = {};

    function ShowRiskLevels() {
        if (AMLQsViewModel.AssessmentTypeFactor().toUpperCase() == "BOTH") {
            AMLQsViewModel.AMLScoreVisible(true);
            AMLQsViewModel.SANCScoreVisible(true);
        }
        else if (AMLQsViewModel.AssessmentTypeFactor().toUpperCase() == "AML") {
            AMLQsViewModel.AMLScoreVisible(true);
            AMLQsViewModel.SANCScoreVisible(false);
        }
        else if (AMLQsViewModel.AssessmentTypeFactor().toUpperCase() == "SANC" || AMLQsViewModel.AssessmentTypeFactor().toUpperCase() == "SANCTIONS") {
            AMLQsViewModel.AMLScoreVisible(false);
            AMLQsViewModel.SANCScoreVisible(true);

        }
    }
    function activate(DataObj) {
        try {

            if (AMLQsViewModel.ObjGeneralSettings === undefined || AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AMLQsViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                AMLQsViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() == null || AMLQsViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        AMLQsViewModel.LocaleCheckFlag(false);
                    else
                        AMLQsViewModel.LocaleCheckFlag(true);
                });
            } else
                AMLQsViewModel.LocaleCheckFlag(true);


            AMLQsViewModel.InherentSetupQualObj(DataObj.InherentSetupQualObj);

            AMLQsViewModel.SelectedScenarioId(AMLQsViewModel.InherentSetupQualObj().ScenarioId);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: activate() method in AMLQuantitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function ToggleNavigationMenu1() {
        var chk2 = $('#NavigationToggle2');
        chk2.prop("checked", false);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").show();
        $("#divjsTree").hide();
    }
    function ToggleNavigationMenu2() {
        var chk1 = $('#NavigationToggle1');
        chk1.prop("checked", true);
        $("#FilterAreaAccordion").toggleClass("collapsedTreeview");
        $("#bottomDivAreaType").toggleClass("col-lg-12 col-lg-9");
        $("#bottomDivAreaType").toggleClass("col-md-12 col-md-9");
        $("#bottomDivAreaType").toggleClass("col-sm-12 col-sm-9");
        $("#bottomDivAreaType").toggleClass("col-xs-12 col-xs-9");
        $("#divNavSwitch2").hide();
        $("#divjsTree").show();
    }
    function CollapseAllTreeView() {
        if ($('#spanExpandAll').text() == ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name())) {
            $('#jsTreeAreaLevelQsWIA').treeview('collapseAll', { silent: true });
            $("#spanExpandAll").text((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton') == -1) ? 'Collapse' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('CollapseButton')].Name());
        }
        else {
            $('#jsTreeAreaLevelQsWIA').treeview('expandAll', { silent: true });
            $("#spanExpandAll").text((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton') == -1) ? 'Expand' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ExpandButton')].Name());
        }
    }
    function ExpandAllTreeView() {
        $('#jsTreeAreaLevelQsWIA').treeview('expandAll', { silent: true });
    }
    function InitiateAreaLevelTree(AssessmentIdList) {
        try {

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            getjsTreeAreaLevelQsWIA = {
                url: "/api/Configuration/GetEALData",
                type: "GET",
                data: { RiskAreType: 'QLDR', SurveyCategoryID: AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId().toString(), AssessmentTypes: AssessmentIdList, ScreenType: 'QLDR' },
                headers: headers
            };
            $.ajax(getjsTreeAreaLevelQsWIA)
                .success(ajaxSuccess)
                .fail(ajaxFail);



        } catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InitiateAreaLevelTree() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, status) {

            $('#loadingImgMainDiv').hide();
            if (jsonResult != null) {
                //implement js tree logic here
                AMLQsViewModel.AreaLeveljstree(jsonResult.AreaLevelsData);
                var MappedJsTreeList = $.map(jsonResult.AreaLevelsData["#"], function (result) {
                    return new jsTreeModel(result);
                });

                $('#jsTreeAreaLevelQsWIA').treeview({
                    data: MappedJsTreeList,
                    onNodeSelected: nodeClickEvent
                });
                var hasChildNodes = ko.utils.arrayFilter(MappedJsTreeList, function (i) { if (i.dead_node != 1) { return i; } }).length > 0
                AMLQsViewModel.hasChildNodes(hasChildNodes);
                //for initial load expand for treeview
                $("#jsTreeAreaLevelQsWIA ul:first li:first").trigger("click");
            }

        }
        function nodeClickEvent(event, node) {
            // Your logic goes here
            if (node.dead_node == 1) {
                $('#QuestionsDiv').hide();
                //select node explicitly in case of recursive calling activity.
                $('#jsTreeAreaLevelQsWIA').treeview('selectNode', [node.nodeId, { silent: true }]);
                $("#tblQuestionResponse tbody tr").remove();
                AMLQsViewModel.CurrentSubRiskAreaId(parseInt(node.id));
                $('#loadingImgMainFactors').show();
                AMLQsViewModel.SelectedAreaName(node.text);
                AMLQsViewModel.CurrentRiskAreaType(node.assessmentTypeList());
                GetAllQuestionsQualitative();

            } else {
                //recursively opening until the dead_node arrives.
                if (!(node.state.expanded))
                    nodeClickEvent(event, node.nodes[0]);
                $('#jsTreeAreaLevelQsWIA').treeview((!(node.state.expanded) ? 'expandNode' : 'collapseNode'), [node.nodeId]);
                $('#jsTreeAreaLevelQsWIA').treeview('unselectNode', [node.nodeId, { silent: true }]);


            }
        }
        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, {
                        buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                    })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllRiskAreas() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllRiskAreas() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        };

    }
    function RiskTypeClick(data, event) {
        try {
            AMLQsViewModel.SelectedAreaType(data.RiskAreaId());
            var AssessmentTypeList = [];

            AMLQsViewModel.AssessmentTypeList().foreach(function (item) {
                AssessmentTypeList.push(item.AssessmentId);
            });
            InitiateAreaLevelTree(AssessmentTypeList.join());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ActionChanged() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function attached() {
        try {

            if (AMLQsViewModel.ObjGeneralSettings === undefined || AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() === undefined || ((AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() !== undefined || AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() !== null) && AMLQsViewModel.ObjGeneralSettings.LocalizedTextList().length === 0)) {
                AMLQsViewModel.ObjGeneralSettings.GetLocalizedData().then(function () {
                    if (AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() == undefined || AMLQsViewModel.ObjGeneralSettings.LocalizedTextList() == null || AMLQsViewModel.ObjGeneralSettings.LocalizedTextList().length <= 0 || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList() == undefined || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList() == null)
                        AMLQsViewModel.LocaleCheckFlag(false);
                    else
                        AMLQsViewModel.LocaleCheckFlag(true);
                });
            }

            $('#error').hide();
            $("#divNavSwitch2").hide();
            $('#loadingImgMainFactors').hide();
            $('#loadingImgMainDiv').show();
            //if (appsecurity.isConfigurationFreeze() === undefined) {
            //    appsecurity.GetConfigurationFreezeFlag().then(function () {
            //        if (appsecurity.WriteAccess() == true && !appsecurity.isConfigurationFreeze()) {
            //            AMLQsViewModel.ControlsAccess(true);
            //        }
            //        else {
            //            AMLQsViewModel.ControlsAccess(false);
            //        }
            //    });
            //}
            //else if (appsecurity.WriteAccess() && !appsecurity.isConfigurationFreeze()) {
            //    AMLQsViewModel.ControlsAccess(true);
            //}
            //else {
                AMLQsViewModel.ControlsAccess(true);
            //}
            GetLanguages();
            GetAllSurveyCategories();
            GetAllInherentLevels();
            GetAllAssessmentTypes();
            GetAllResponseTypes();
            GetAllOptionsType();
            var url = window.location.pathname;
            AMLQsViewModel.CurrentScreenName(url.substring(url.lastIndexOf('/') + 1));
            QuestionTableObj = $('#tblQualQuestions').DataTable({ "bVisible": false });
            $($(document.getElementsByClassName('list-group-item')).get(4)).addClass('active');
            $($(document.getElementsByClassName('nav navbar-nav navbar-left')).get(4)).addClass('active');
            $('#tblQualQuestions').on('page.dt', function (event) {
                CheckExpandedRow("", true);
                AMLQsViewModel.CurrentPageNumber(QuestionTableObj.page());
            });
            GetRiskSubAreasBySurveyCategory();
            $(document).ready(function () {
                $('[data-toggle="tooltip"]').tooltip();
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: attached() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function detached() {
        try {
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: detached() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function addResponseType() {
        try {
            var newResponseObject = { "RESPONSE_ID": null, "RESPONSE_NAME": null, "RESPONSE_DESCRIPTION": null, "RESPONSE_WEIGHTS": null };
            AMLQsViewModel.ResponseTypeList.push(newResponseObject);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in addRiskArea() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }

    function deleteResponseButton(data) {
        try {
            app.showMessage('Are you sure you want to Delete this Response Level?' + "<br/><br/><b>", 'Delete Request', ['Confirm', 'Cancel'], false, { popupIcon: 'title-icon col-md-1 fa fa-trash' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        deleteResponseItem(data);

                    }
                });
            return false;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: deleteResponseButton() method in ControlAreaSetup.js';
            logger.logMessage(msg);
        }
    }

    //deleteResponseItem



    function deleteResponseItem(data) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            addNewResponseType = {
                url: "/api/Configuration/deleteResponseItem",
                type: "POST",
                data: { RESPONSE_ID: data.RESPONSE_ID, RESPONSE_DESCRIPTION: data.RESPONSE_DESCRIPTION },
                headers: headers,
                async: false
            };
            $.ajax(addNewResponseType)
                .success(deleteResponseSuccess)
                .fail(deleteResponseFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in deleteResponseItem() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
        function deleteResponseSuccess(jsonResult, status) {
            try {
                $('#ResponseTypeError').hide();
                if (jsonResult == 2) {
                    logger.logError('The Response cannot be deleted as it is used in the Application.', 'Error', system.getModuleId(AMLQsViewModel), true);

                }
                else if (jsonResult != null) {
                    GetAllResponseTypes();
                    AMLQsViewModel.IsDeletedFlag(true);
                }
                else
                    logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in deleteResponseItem() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function deleteResponseFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Delete Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in deleteResponseItem() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in deleteResponseItem() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

    }

    function GetAllAreaType() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            return $.ajax({
                url: "/api/Configuration/GetAllAreaType",
                headers: headers,
                type: "GET",
            })
                .success(function (jsonResult, success) {
                    if (jsonResult != null && jsonResult.length != 0) {
                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            return new RiskAreaModel(result);
                        });
                        AMLQsViewModel.RiskAreaTypeList(MappedAssessmentList);
                        $('#DivForAreaType').show();
                        $("#RiskAreatypeDiv").tabs();
                        $('#RiskAreatypeDiv').tabs('refresh');
                        $('#RiskAreatypeDiv').tabs({ active: 0 });
                        $($('#RiskAreatypeDiv li').get(0)).trigger('click');
                    }
                    else {
                        AMLQsViewModel.SelectedAreaType(null);
                        $('#DivForAreaType').hide();
                    }
                })
                .fail(function (error, status) {
                    if (error.status == 401) {
                        app.showMessage(
                            ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name)
                            , "Error in Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllAreaType() method in QualitativeSetup.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAreaType() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }


    function updateResponseItem() {
        try {
            var total = 0;
            for (i = 0; i < AMLQsViewModel.ResponseTypeList().length; i++) {
                if (AMLQsViewModel.ResponseTypeList()[i].RESPONSE_NAME === null) {
                    $('#ResponseTypeError').show();
                    $('#ResponseTypeError').text(
                        //'Response Name can not be empty'
                        ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseNameNotEmpty') == -1) ? 'Response Name can not be empty.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseNameNotEmpty')].Name)
                    );
                    return false;
                }
                if (AMLQsViewModel.ResponseTypeList()[i].RESPONSE_WEIGHTS === null) {
                    AMLQsViewModel.ResponseTypeList()[i].RESPONSE_WEIGHTS = 0;
                }
                total += parseFloat(AMLQsViewModel.ResponseTypeList()[i].RESPONSE_WEIGHTS);
            }
            if (AMLQsViewModel.ResponseTypeList().length != 0) {
                if (total != 100.00) {
                    $('#ResponseTypeError').show();
                    $('#ResponseTypeError').text(
                        //'Response Weightage must sum upto complete 100%'
                        ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseWeightageSum') == -1) ? 'Response Weightage must sum upto complete 100%' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseWeightageSum')].Name)
                    );
                    return false;
                }
            }
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            addNewResponseType = {
                url: "/api/Configuration/AddUpdateResponseType",
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(AMLQsViewModel.ResponseTypeList(), function (item) {
                    return { "RESPONSE_ID": item.RESPONSE_ID, "RESPONSE_NAME": item.RESPONSE_NAME, "RESPONSE_DESCRIPTION": item.RESPONSE_DESCRIPTION, "RESPONSE_WEIGHTS": item.RESPONSE_WEIGHTS };
                })),
                headers: headers,
                async: false
            };
            $.ajax(addNewResponseType)
                .success(addResponseTypeSuccess)
                .fail(addResponseTypeFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in updateResponseItem() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
        function addResponseTypeSuccess(jsonResult, status) {
            try {
                if (jsonResult != null) {
                    if ($.fn.dataTable.isDataTable('#QualResponseTypeTable')) {
                        $('#QualResponseTypeTable').DataTable({ retrieve: true }).destroy();
                        $('#QualResponseTypeTable tbody tr').remove();
                    }
                    AMLQsViewModel.ResponseTypeList(jsonResult);
                    $('#QualResponseTypeTable').DataTable({
                        searching: false,
                        ordering: false
                    });
                    $('#ResponseTypeError').hide();
                    logger.logSuccess(
                        //'Response types saved successfully.'
                        ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Responsetypessaved') == -1) ? 'Response types saved successfully.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Responsetypessaved')].Name)
                        , 'Success', system.getModuleId(AMLQsViewModel), true);

                }
                else
                    logger.logError('An error occurred. Please contact your Administrator.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in updateResponseItem() method in RiskAreas.js';
                logger.logMessage(msg);
            }
        }

        function addResponseTypeFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in updateResponseItem() method in RiskArea&Factor.js';
                    logger.logMessage(msg);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in updateResponseItem() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

    }

    function ActionChanged(data) {
        if (data.RiskMapping() === "")
            BindDynamicHtmlForDropDowns();
        else {
            var RiskMapping = data.RiskMapping();
            RiskMapping = RiskMapping + "|" + AMLQsViewModel.SelectedAssessmentTypeSubFactor().toString().trim();
            BindDynamicHtmlForDropDownsEdit(RiskMapping.split('|'));
        }
    }

    function BindDynamicHtmlForDropDowns() {
        try {
            $('#DynamicScoreDiv').empty();
            var DynamicHTMl = "";
            for (var j = 0; j < AMLQsViewModel.SelectedAssessmentTypeSubFactor().length; j++) {
                for (var i = 0; i < AMLQsViewModel.AssessmentTypeList().length; i++) {
                    if (parseInt(AMLQsViewModel.SelectedAssessmentTypeSubFactor()[j]) == AMLQsViewModel.AssessmentTypeList()[i].AssessmentId()) {

                        DynamicHTMl += '<div class="form-group d-flex" id="appSubfactor">' +
                            '<label class="lg-4 mr-2 control-label">' + AMLQsViewModel.AssessmentTypeList()[i].AssessmentName() + ' Risk Score :</label>' +
                            '<div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">' +
                            '<select id="' + AMLQsViewModel.AssessmentTypeList()[i].AssessmentId() + 'AddScore" data-bind="foreach:{data: InherentRiskLevelList, as: \'List1\'}" class="form-control">' +
                            '<!-- ko if: (List1.AssessmentTypeId ==' + parseInt(AMLQsViewModel.SelectedAssessmentTypeSubFactor()[j]) + '|| List1.AssessmentTypeId == 99999)-->' +
                            '<!-- ko if: !(List1.isQuantitative ==1)-->' +
                            '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                            '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                            '</optgroup>' +
                            '<!--/ko -->' +
                            '<!--/ko -->' +
                            '</select>' +

                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl
            ko.cleanNode(document.getElementById('DynamicScoreDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicScoreDiv"));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDowns() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function GetAllAssessmentTypes() {
        try {
            $.ajax({
                url: "/api/Visualization/GetAssessmentTypesByCategory",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "ZATId": AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(), "ScenarioId": AMLQsViewModel.SelectedScenarioId() }
            })
                .success(function (jsonResult, error) {
                    var AssessmentIdArray = [];
                    AMLQsViewModel.AssessmentTypeList([]);
                    if (jsonResult != null) {

                        var MappedAssessmentList = $.map(jsonResult, function (result) {
                            AssessmentIdArray.push(result.AssessmentId);
                            return new AssessmentListModel(result);
                        });
                        AMLQsViewModel.AssessmentTypeList(MappedAssessmentList);

                        InitiateAreaLevelTree(AssessmentIdArray.join());
                    }
                    else {
                        $('#Assessmenterror').show();
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()), 'Error', system.getModuleId(AMLQsViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    //Function to bind the survey categories Dropdown Dynamically starts here
    function GetAllSurveyCategories() {
        try {
            var headers = appsecurity.getSecurityHeaders();
            $.ajax({
                url: "/api/Configuration/GetAllSurveyCategories",
                type: "GET",
                headers: headers
            })
                .success(function (jsonResult, error) {
                    if (jsonResult != null && jsonResult.length > 0) {

                        AMLQsViewModel.ZATRATList([]);
                        for (var i = 0; i < jsonResult.length; i++) {

                            var splitID = $.map(jsonResult[i].AssessmentTypeId.split(","), $.trim);
                            for (var j = 0; j < splitID.length; j++) {
                                AMLQsViewModel.ZATRATList().push(new ZATRATModel(jsonResult[i].SurveyCategoryId, jsonResult[i].SurveyCategoryName, splitID[j], jsonResult[i].SurveyGroupShortName));
                            }

                        }
                        AMLQsViewModel.ZATRATListDup(AMLQsViewModel.ZATRATList());

                    }

                    else
                        logger.logError(
                            //'Some error occured while fetching the Survey Categories. Please contact your Administrator.'
                            ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchSurveyCategoriesError') == -1) ? 'Some error occured while fetching the Survey Categories. Please contact your Administrator.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchSurveyCategoriesError')].Name)
                            , 'Error', system.getModuleId(AMLQsViewModel), true);

                })
                .fail(function (error, status) {
                    logger.logError(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()), 'Error', system.getModuleId(AMLQsViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteAssessmentType() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }

    }

    function GetAllResponseTypes() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllResponseTypes",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, error) {
                    AMLQsViewModel.ResponseTypeList([]);
                    if (jsonResult != null) {
                        if ($.fn.dataTable.isDataTable('#QualResponseTypeTable')) {
                            $('#QualResponseTypeTable').DataTable({ retrieve: true }).destroy();
                            $('#QualResponseTypeTable tbody tr').remove();
                        }
                        AMLQsViewModel.ResponseTypeList(jsonResult);
                        $('#QualResponseTypeTable').DataTable({
                            searching: false,
                            ordering: false
                        });
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()), 'Error', system.getModuleId(AMLQsViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllAssessmentTypes() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function GetAllOptionsType() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllOptionsType",
                type: "GET",
                headers: appsecurity.getSecurityHeaders()
            })
                .success(function (jsonResult, error) {
                    AMLQsViewModel.OptionsTypeList([]);
                    if (jsonResult != null) {
                        AMLQsViewModel.OptionsTypeList(jsonResult);
                    }
                })
                .fail(function (jsonResult, error) {
                    logger.logError(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError') == -1) ? 'An error has occurred while fetching the type assessments. Please contact your Administrator.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('FetchAssessmentsError')].Name()), 'Error', system.getModuleId(AMLQsViewModel), true);
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllOptionsType() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function ApplicabilityRelEvents(data, event) {
        try {
            var selectedassessments = [];
            if (AMLQsViewModel.SelectedAssessmentTypeFactor() != undefined) {
                for (var i = 0; i < AMLQsViewModel.SelectedAssessmentTypeFactor().length; i++) {
                    selectedassessments.push(AMLQsViewModel.SelectedAssessmentTypeFactor()[i].toString().trim());
                }
            }
            if (AMLQsViewModel.SelectedAssessmentTypeFactorEdit() != undefined) {
                for (var i = 0; i < AMLQsViewModel.SelectedAssessmentTypeFactorEdit().length; i++) {
                    selectedassessments.push(AMLQsViewModel.SelectedAssessmentTypeFactorEdit()[i].toString().trim());
                }
            }
            var selectedAreas = [];
            if (data.CopyOverAreas() != undefined)
                selectedAreas = data.CopyOverAreas().split(',');
            var FilteredAreaList = [];
            AMLQsViewModel.RiskAreaDropDownList([]);
            var countTemp = 0;
            var areaListLength = 0;

            for (var i = 0; i < AMLQsViewModel.RiskSubAreasListforZAT().length; i++) {
                InnerLoops:
                for (var j = 0; j < AMLQsViewModel.RiskSubAreasListforZAT()[i].MappedAssessmentType().length; j++) {
                    for (var k = 0; k < selectedassessments.length; k++) {
                        if (AMLQsViewModel.RiskSubAreasListforZAT()[i].MappedAssessmentType()[j].ID.toString() === selectedassessments[k].toString() &&
                            AMLQsViewModel.RiskSubAreasListforZAT()[i].RiskAreaId() != AMLQsViewModel.CurrentSubRiskAreaId()) {

                            if (selectedAreas.length === 0) {
                                FilteredAreaList.push(AMLQsViewModel.RiskSubAreasListforZAT()[i]);
                            }
                            else {
                                countTemp = 0;
                                for (var l = 0; l < selectedAreas.length; l++) {
                                    if (AMLQsViewModel.RiskSubAreasListforZAT()[i].RiskAreaId() === parseInt(selectedAreas[l])) {
                                        countTemp++;
                                    }
                                }
                                if (countTemp === 0)
                                    FilteredAreaList.push(AMLQsViewModel.RiskSubAreasListforZAT()[i]);
                            }
                            break InnerLoops;
                        }
                    }
                }
            }
            areaListLength = AMLQsViewModel.RiskSubAreasListforZAT().length;


            AMLQsViewModel.RiskAreaDropDownList(FilteredAreaList);
            if (data.CopyOverAreas() != undefined) {
                if (data.CopyOverAreas().split(',').length === areaListLength) {
                    $('#CopyOverAreasAppTypeID').hide();
                    $('#copyoverinfo').hide();
                }
                else {
                    $('#CopyOverAreasAppTypeID').multiselect();
                    $('#CopyOverAreasAppTypeID').multiselect('refresh');
                }
            }
            else {
                $('#CopyOverAreasAppTypeID').multiselect();
                $('#CopyOverAreasAppTypeID').multiselect('refresh');
            }
            CopyOverEventClick(data, event);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ApplicabilityRelEvents() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function CopyOverEventClick(data, event) {
        try {
            var selectedassessments = [];
            if (AMLQsViewModel.SelectedAssessmentTypeFactor() != undefined) {
                for (var i = 0; i < AMLQsViewModel.SelectedAssessmentTypeFactor().length; i++) {
                    selectedassessments.push(AMLQsViewModel.SelectedAssessmentTypeFactor()[i].toString().trim());
                }
            }
            if (AMLQsViewModel.SelectedAssessmentTypeFactorEdit() != undefined) {
                for (var i = 0; i < AMLQsViewModel.SelectedAssessmentTypeFactorEdit().length; i++) {
                    selectedassessments.push(AMLQsViewModel.SelectedAssessmentTypeFactorEdit()[i].toString().trim());
                }
            }
            var selectedCopyOverAreas = [];

            if (AMLQsViewModel.EditFactorVisible() === false) {
                selectedCopyOverAreas.push(AMLQsViewModel.CurrentSubRiskAreaId().toString().trim());
            }
            if (AMLQsViewModel.SelectedCopyOverAreas() != undefined) {
                for (var i = 0; i < AMLQsViewModel.SelectedCopyOverAreas().length; i++) {
                    selectedCopyOverAreas.push(AMLQsViewModel.SelectedCopyOverAreas()[i].toString().trim());
                }
            }
            if (AMLQsViewModel.SelectedCopyOverAreasEdit() != undefined) {
                for (var i = 0; i < AMLQsViewModel.SelectedCopyOverAreasEdit().length; i++) {
                    selectedCopyOverAreas.push(AMLQsViewModel.SelectedCopyOverAreasEdit()[i].toString().trim());
                }
            }
            selectedassessments.sort();
            selectedCopyOverAreas.sort();
            var selectedassessmentsString = "";
            for (var i = 0; i < selectedassessments.length; i++) {
                if (i === 0)
                    selectedassessmentsString += selectedassessments[i].toString().trim();
                else
                    selectedassessmentsString += ',' + selectedassessments[i].toString().trim();
            }
            var selectedCopyOverAreasString = "";
            for (var i = 0; i < selectedCopyOverAreas.length; i++) {
                if (i === 0)
                    selectedCopyOverAreasString += selectedCopyOverAreas[i].toString().trim();
                else
                    selectedCopyOverAreasString += ',' + selectedCopyOverAreas[i].toString().trim();
            }
            var MappedHeaderList = [];
            AMLQsViewModel.HeaderFactorsDropDownList([]);

            for (var h = 0; h < AMLQsViewModel.HeaderFactorsList().length; h++) {
                var ApplicableRATIds = AMLQsViewModel.HeaderFactorsList()[h].ApplicableRATId().split(',');
                var ApplicableAreaIds = AMLQsViewModel.HeaderFactorsList()[h].ApplicableAreaIds().split(',');
                ApplicableRATIds.sort();
                ApplicableAreaIds.sort();
                var ApplicableRATIdString = "";
                var ApplicableAreaIdsString = "";
                for (var i = 0; i < ApplicableRATIds.length; i++) {
                    if (i === 0)
                        ApplicableRATIdString += ApplicableRATIds[i].toString().trim();
                    else
                        ApplicableRATIdString += ',' + ApplicableRATIds[i].toString().trim();
                }
                for (var i = 0; i < ApplicableAreaIds.length; i++) {
                    if (i === 0)
                        ApplicableAreaIdsString += ApplicableAreaIds[i].toString().trim();
                    else
                        ApplicableAreaIdsString += ',' + ApplicableAreaIds[i].toString().trim();
                }
                if ((selectedassessmentsString.toString() === ApplicableRATIdString.toString() && selectedCopyOverAreasString.toString() === ApplicableAreaIdsString.toString()) ||
                    (ApplicableRATIdString.toString().includes(selectedassessmentsString.toString()) && ApplicableAreaIdsString.toString().includes(selectedCopyOverAreasString.toString()))) {
                    if (data.QuestionId() != AMLQsViewModel.HeaderFactorsList()[h].HeaderSubFactorId())
                        MappedHeaderList.push(AMLQsViewModel.HeaderFactorsList()[h]);
                }
            }

            AMLQsViewModel.HeaderFactorsDropDownList(MappedHeaderList);
            AMLQsViewModel.HeaderFactorsDropDownList.valueHasMutated();
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CopyOverEventClick() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function GetQualHeadersByRiskArea() {
        try {
            var ParentUID = 0;
            $.ajax({
                url: "/api/Configuration/GetQualHeadersByRiskArea",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { "SurveyCategoryId": AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(), "ParentId": parseInt(ParentUID.toString()) }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetQualHeadersByRiskArea() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, error) {
            try {
                AMLQsViewModel.HeaderFactorsList([]);
                if (jsonResult !== null && jsonResult.length > 0) {
                    var mappedHeaders = $.map(jsonResult, function (result) {
                        return new RiskFactorHeaderModel(result);
                    });
                    AMLQsViewModel.HeaderFactorsList(mappedHeaders);
                }
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in  GetQualHeadersByRiskArea() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                } else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQualHeadersByRiskArea() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxfail in GetQualHeadersByRiskArea() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetRiskSubAreasBySurveyCategory() {
        try {
            $.ajax({
                url: "/api/Configuration/GetRiskSubAreasBySurveyCategory",
                data: { "SurveyCategoryId": AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId() },
                type: "GET",
                headers: appsecurity.getSecurityHeaders()

            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetRiskSubAreasBySurveyCategory() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            try {
                if (jsonResult !== null && jsonResult.length > 0) {

                    AMLQsViewModel.RiskSubAreasListforZAT([]);
                    var mappedRiskSubAreaList = $.map(jsonResult, function (result) {
                        return new RiskSubAreaModel(result);
                    });
                    AMLQsViewModel.RiskSubAreasListforZAT(mappedRiskSubAreaList);
                }
                else
                    logger.logError('Some error occured while fetching the Sub Areas for Survey Category. Please contact your Administrator.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetRiskSubAreasBySurveyCategory() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }
        function ajaxFail(error, status) {

            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, {
                        buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login'
                    })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        });
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetRiskSubAreasBySurveyCategory() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetRiskSubAreasBySurveyCategory() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }
    }

    function GetLanguages() {
        AMLQsViewModel.ObjGeneralSettings.getLanguages();
        AMLQsViewModel.LanguageList = AMLQsViewModel.ObjGeneralSettings.LanguageList();
        if (AMLQsViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
            AMLQsViewModel.LanguageList.splice(0, 1);
        }
    }
    function changedResponseType() {
        try {
            AMLQsViewModel.ResponseOptionList([]);
            for (var i = 0; i < AMLQsViewModel.SelectedResponseTypeFactor().length; i++) {
                for (var j = 0; j < AMLQsViewModel.ResponseTypeList().length; j++) {
                    if (AMLQsViewModel.SelectedResponseTypeFactor()[i] == AMLQsViewModel.ResponseTypeList()[j].RESPONSE_ID) {
                        AMLQsViewModel.ResponseOptionList.push(new ResponseOptionModel({ "ResponseTypeId": AMLQsViewModel.ResponseTypeList()[j].RESPONSE_ID, "ResponseTypeName": AMLQsViewModel.ResponseTypeList()[j].RESPONSE_NAME, "OptionTypeShortName": "" }));
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajaxFail in changedResponseType() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    // Risk Area Language change event
    function QualAreaLanguageAdded() {
        try {
            $('#DynamicQualRiskAreaNameDiv').empty();
            var RiskAreaNameHTMl = "";

            $('#DynamicQualRiskAreaCommentsDiv').empty();
            var CommentsHTMl = "";

            for (var j = 0; j < AMLQsViewModel.SelectedLanguageQualAreaType().length; j++) {
                for (var i = 0; i < AMLQsViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(AMLQsViewModel.SelectedLanguageQualAreaType()[j]) == AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {

                        RiskAreaNameHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Risk Area Name (' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<input id="riskareaname' + AMLQsViewModel.SelectedLanguageQualAreaType()[j] + '" class="form-control" placeholder="Risk Area Name in ' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: QualRiskAreaSubList().RiskAreaName" type="text" />' +
                            '</div>' +
                            '</div>';

                        CommentsHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Comments (' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                            '<div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">' +
                            '<textarea id="EditRaTextArea' + AMLQsViewModel.SelectedLanguageQualAreaType()[j] + '" class="form-control" rows="5" placeholder="Risk Area Notes in ' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value:QualRiskAreaSubList().RiskAreaNotes" name="Notes" ></textarea>' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicQualRiskAreaNameDiv').innerHTML = RiskAreaNameHTMl;
            ko.cleanNode(document.getElementById('DynamicQualRiskAreaNameDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicQualRiskAreaNameDiv"));

            document.getElementById('DynamicQualRiskAreaCommentsDiv').innerHTML = CommentsHTMl;
            ko.cleanNode(document.getElementById('DynamicQualRiskAreaCommentsDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicQualRiskAreaCommentsDiv"));

            if (RiskAreaNameHTMl != "" && CommentsHTMl != "") {
                $("#frmAreaRiskScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "65rem" });
            }
            else
                $("frmAreaRiskScroll").removeAttr("style");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualAreaLanguageAdded() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function QualSubAreaLanguageAdded() {
        try {
            $('#DynamicQualRiskSubAreaNameDiv').empty();
            var RiskAreaNameHTMl = "";

            $('#DynamicQualRiskSubAreaCommentsDiv').empty();
            var CommentsHTMl = "";

            for (var j = 0; j < AMLQsViewModel.SelectedLanguageQualSubAreaType().length; j++) {
                for (var i = 0; i < AMLQsViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(AMLQsViewModel.SelectedLanguageQualSubAreaType()[j]) == AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID()) {

                        RiskAreaNameHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Risk Area Name (' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ') </label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<input id="riskareaname' + AMLQsViewModel.SelectedLanguageQualSubAreaType()[j] + '" class="form-control" placeholder="Risk Area Name in ' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + '" data-bind="value: QualRiskSubAreaSubList().RiskAreaName" type="text" />' +
                            '</div>' +
                            '</div>';

                        CommentsHTMl += '<div class="form-group">' +
                            '<label class="col-xs-3 col-sm-3 col-md-3 col-lg-3 control-label">Comments (' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<textarea id="EditRsaTextArea' + AMLQsViewModel.SelectedLanguageQualSubAreaType()[j] + '" class="form-control" rows="5" placeholder="Risk Area Notes in ' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + '" data-bind="value:QualRiskSubAreaSubList().RiskAreaNotes" name="Notes" ></textarea>' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicQualRiskSubAreaNameDiv').innerHTML = RiskAreaNameHTMl;
            ko.cleanNode(document.getElementById('DynamicQualRiskSubAreaNameDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicQualRiskSubAreaNameDiv"));

            document.getElementById('DynamicQualRiskSubAreaCommentsDiv').innerHTML = CommentsHTMl;
            ko.cleanNode(document.getElementById('DynamicQualRiskSubAreaCommentsDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicQualRiskSubAreaCommentsDiv"));

            if (RiskAreaNameHTMl != "" && CommentsHTMl != "") {
                $("#frmAreaRiskScroll").css({ "height": "auto", "max-height": "50rem", "overflow-y": "scroll", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "65rem" });
            }
            else
                $("frmAreaRiskScroll").removeAttr("style");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualSubAreaLanguageAdded() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function GetAllInherentLevels() {
        try {
            $.ajax({
                url: "/api/Configuration/GetAllInherentLevelswithNA",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: { AssessmentId: 0, SurveyCategoryId: AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId() }
            })
                .success(function (jsonResult, Error) {
                    if (jsonResult == 0 || jsonResult == null) {
                    }
                    else {
                        var mappedIRSData = $.map(jsonResult, function (result) {
                            return new RiskLevelModel(result);
                        });
                        var mappedIRSDataDup = $.map(jsonResult, function (result) {
                            return new RiskLevelModel(result);
                        });
                        AMLQsViewModel.InherentRiskLevelListDup(mappedIRSDataDup);
                        AMLQsViewModel.InherentRiskLevelList(mappedIRSData);
                    }
                })
                .fail(function (jsonResult, log) {
                    if (error.status == 401) {
                        app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllInherentLevels() method in QualitativeSetup.js';
                        logger.logMessage(msg);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: GetAllInherentLevels() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------------------------------Logic Related to Qualitative Questions Starts Here---------------------------------------------------------------------------



    function truncate(str) {
        str.area_name_truncated = str.area_name.split(" ").splice(0, 2).join(" ");
        if (str.area_name_truncated === str.area_name)
            str.area_name_truncated = str.area_name;
        else
            str.area_name_truncated += '...';
        return str;
    }

    function GetAllQuestionsQualitative() {
        try {
            var RiskAreaId;

            RiskAreaId = AMLQsViewModel.CurrentSubRiskAreaId();

            $.ajax({
                url: "/api/Qualitative/GetAllQualitativeQuestions",
                type: "GET",
                data: {
                    "RiskAreaId": RiskAreaId, "SurveyCategoryID": AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(),
                    "AssessmentTypes": AMLQsViewModel.InherentSetupQualObj().data.AssessmentTypeId()
                },
                headers: appsecurity.getSecurityHeaders()
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetAllQualitativeQuestions() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {

                $("#tblQualQuestions tbody tr").remove();

                $('#loadingMainImgDiv').hide();
                $('#loadingImgMainFactors').hide();
                $('#QuestionsDiv').show();
                if (jsonResult != null && jsonResult.lstAreaLevelModel.length > 0) {
                    if (AMLQsViewModel.QuestionsList().length > 0)
                        CheckExpandedRow("", true);
                    AMLQsViewModel.QuestionsList([]);
                    AMLQsViewModel.RiskAreaQuestionReorderList([]);
                    AMLQsViewModel.RiskAreaQuestionReorderListDup([]);
                    AMLQsViewModel.SelectedLanguageSubFactorType([]);
                    AMLQsViewModel.SubFactorRiskAreaList([]);
                    QuestionTableObj.clear().destroy();
                    $('#tblQualQuestions tbody tr').remove();
                    AMLQsViewModel.QuestionsList([]);

                    var new_array = jsonResult.lstAreaLevelModel.map(function truncate(str) {
                        str.area_name_truncated = str.area_name.split(" ").splice(0, 2).join(" ");
                        if (str.area_name_truncated === str.area_name)
                            str.area_name_truncated = str.area_name;
                        else
                            str.area_name_truncated += '...';
                        return str;
                    });

                    AMLQsViewModel.BreadCrumbArray(new_array);
                    var MappedQuestions = $.map(jsonResult.lstQuestionModel, function (result) {
                        return new QualitativeQuestionsModel(result);
                    })
                    AMLQsViewModel.RiskQuestionSortOrder(0);
                    var MappedQuestionsSortOrder = $.map(jsonResult.lstQuestionModel, function (result) {
                        return new QualitativeQuestionsSortOrderModel(result);
                    })
                    AMLQsViewModel.RiskQuestionSortOrder(0);
                    var MappedQuestionsSortOrderDup = $.map(jsonResult.lstQuestionModel, function (result) {
                        return new QualitativeQuestionsSortOrderModel(result);
                    })
                    AMLQsViewModel.RiskAreaQuestionReorderList(MappedQuestionsSortOrder);
                    AMLQsViewModel.RiskAreaQuestionReorderListDup(MappedQuestionsSortOrderDup);
                    AMLQsViewModel.QuestionsList(MappedQuestions);

                    AMLQsViewModel.ParentFactorList([]);
                    AMLQsViewModel.ParentFactorList(MappedQuestions);

                    QuestionTableObj = undefined;
                    QuestionTableObj = $('#tblQualQuestions').DataTable({
                        "bResponsive": true,
                        "stateSave": true,
                        "aoColumnDefs": [{
                            "aTargets": [0],
                            "bVisible": true

                        }, {
                            "aTargets": [1],
                            "bVisible": false,
                            "bSortable": false

                        }, {
                            "aTargets": [2],
                            "bVisible": true
                        },
                        {
                            "aTargets": [3],
                            "bSortable": true
                        },
                        {
                            "aTargets": [4],
                            "bSortable": true
                        },
                        {
                            "aTargets": [5],
                            "bSortable": true
                        },

                        {
                            "aTargets": [6],
                            "bSortable": false,
                            "bVisible": AMLQsViewModel.ControlsAccess()
                        }]

                    });
                    $('#tblQualQuestions').DataTable().draw(false);
                    AMLQsViewModel.CurrentPageNumber(QuestionTableObj.page());
                    GetQualHeadersByRiskArea();
                }
                else if (jsonResult.lstQuestionModel.length == 0) {
                    AMLQsViewModel.BreadCrumbArray(jsonResult.lstAreaLevelModel);
                    CheckExpandedRow("", true);
                    AMLQsViewModel.QuestionsList([]);
                    AMLQsViewModel.RiskAreaQuestionReorderList([]);
                    AMLQsViewModel.RiskAreaQuestionReorderListDup([]);
                    QuestionTableObj.destroy();
                    $('#tblQualQuestions tbody tr').remove();
                    AMLQsViewModel.QuestionsList([]);
                    AMLQsViewModel.RiskAreaQuestionReorderList([]);
                    AMLQsViewModel.RiskAreaQuestionReorderListDup([]);

                    QuestionTableObj = $('#tblQualQuestions').DataTable({
                        "bResponsive": true,
                        "stateSave": true,
                        "aocolumndefs": [{
                            "atargets": [0],
                            "bsortable": false,
                            "sclass": "details-control action-bgcolor"
                        },
                        {
                            "atargets": [1],
                            "bvisible": false
                        },
                        {
                            "atargets": [7],
                            "sclass": "text-center",
                            "bsortable": false,
                            "bvisible": (AMLQsViewModel.ControlsAccess()) ? true : false
                        }]

                    });
                    $('#tblQualQuestions').DataTable().draw(false);

                }
                else
                    logger.logError('An error occurred while fetching Qualitative Questions.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetAllQualitativeQuestions() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetAllQualitativeQuestions() method in AMLQualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetAllQualitativeQuestions() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function LanguageFactorAdded() {
        try {
            $('#DynamicRiskFactorDiv').empty();
            var QuestionNameHTMl = "";

            $('#DynamicScenariosDiv').empty();
            var ScenariosHTMl = "";

            for (var j = 0; j < AMLQsViewModel.SelectedLanguageFactorType().length; j++) {
                for (var i = 0; i < AMLQsViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(AMLQsViewModel.SelectedLanguageFactorType()[j]) == AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {


                        QuestionNameHTMl += '<div class="form-group">' +
                            '<label class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label">Risk Factor (' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<input id="questionname' + AMLQsViewModel.SelectedLanguageFactorType()[j] + '" class="form-control" placeholder="Question Name in ' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value: RiskAreaSubList().RiskAreaName" type="text" />' +
                            '</div>' +
                            '</div>';

                        ScenariosHTMl += '<div class="form-group">' +
                            '<label class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label">Scenarios (' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ')</label>' +
                            '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                            '<textarea id="ScenariosFactorTextArea' + AMLQsViewModel.SelectedLanguageFactorType()[j] + '" class="form-control" placeholder="Question in ' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME._latestValue + '" data-bind="value:RiskAreaSubList().RiskAreaNotes" type="text" ></textarea>' +
                            '</div>' +
                            '</div>';
                    }
                }
            }
            document.getElementById('DynamicRiskFactorDiv').innerHTML = QuestionNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicRiskFactorDiv"));

            document.getElementById('DynamicScenariosDiv').innerHTML = ScenariosHTMl;
            ko.cleanNode(document.getElementById('DynamicScenariosDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicScenariosDiv"));

            if (QuestionNameHTMl != "" && ScenariosHTMl != "") {
                $("#frmQualitativeQuestionsScroll").css({ "height": "auto", "max-height": "auto", "overflow-y": "auto", "overflow-x": "hidden" });
                $("modalContent").css({ "height": "auto", "max-height": "auto" });
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: LanguageFactorAdded() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicFactorElements(item) {
        try {
            $('#DynamicRiskFactorDiv').empty();
            var QuestionNameHTMl = "";

            $('#DynamicScenariosDiv').empty();
            var ScenariosHTMl = "";

            $.each(item, function (key, value) {
                QuestionNameHTMl += '<div class="form-group">' +
                    '<label class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label">Risk Factor (' + GetLanguageName(value.LanguageType) + ')</label>' +
                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                    '<input id="questionname' + value.LanguageType + '" class="form-control" data-bind="value: RiskAreaSubList().RiskAreaName" type="text" />' +
                    '</div>' +
                    '</div>';

                ScenariosHTMl += '<div class="form-group">' +
                    '<label class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label">Scenarios (' + GetLanguageName(value.LanguageType) + ')</label>' +
                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                    '<textarea id="ScenariosFactorTextArea' + value.LanguageType + '" class="form-control" data-bind="value:RiskAreaSubList().RiskAreaNotes" type="text" ></textarea>' +
                    '</div>' +
                    '</div>';
            });

            document.getElementById('DynamicRiskFactorDiv').innerHTML = QuestionNameHTMl;
            ko.cleanNode(document.getElementById('DynamicRiskFactorDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicRiskFactorDiv"));

            document.getElementById('DynamicScenariosDiv').innerHTML = ScenariosHTMl;
            ko.cleanNode(document.getElementById('DynamicScenariosDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicScenariosDiv"));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddDynamicFactorElements() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }


    function resetRadioButtons(data, event) {
        try {
            AMLQsViewModel.FactorReadOnlyType(false);
            AMLQsViewModel.FactorHeaderType(false);
            AMLQsViewModel.FactorConditionalType(false);
            document.getElementById("ReadOnlyTypeFactor").checked = false;
            document.getElementById("HeaderTypeFactor").checked = false;
            document.getElementById("ConditionalTypeFactor").checked = false;
            $('#FactorRespTypeID').multiselect();
            return true;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: resetRadioButtons() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function AddDynamicSubFactorElements(item) {
        try {
            $('#DynamicResponseDiv').empty();
            var ResponseHTMl = "";

            $.each(item, function (key, value) {
                ResponseHTMl += '<div class="form-group">' +
                    '<label class="col-xs-4 col-sm-4 col-md-4 col-lg-4 control-label">Response (' + GetLanguageName(value.LanguageType) + ')</label>' +
                    '<div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">' +
                    '<input id="response' + value.LanguageType + '" class="form-control" data-bind="value: SubFactorRiskAreaList().RiskAreaName" type="text" />' +
                    '</div>' +
                    '</div>';
            });

            document.getElementById('DynamicResponseDiv').innerHTML = ResponseHTMl;
            ko.cleanNode(document.getElementById('DynamicResponseDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicResponseDiv"));

            if (item.length > 2)
                $("#frmQualitativeResponseScroll").css({ "height": "35rem", "overflow-y": "scroll", "overflow-x": "hidden" });
            else
                $('#frmQualitativeResponseScroll').removeAttr("style");
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddDynamicSubFactorElements() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function RiskFactor(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#questionname' + item).val();
            self.RiskAreaNotes = $('#ScenariosFactorTextArea' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactor() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    };
    function RiskAreaSubFactor(item) {
        try {
            var self = this;
            self.RiskAreaName = $('#response' + item).val();
            self.LanguageType = item;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaSubFactor() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    };

    function MakePipeDelimited(Response) {
        try {


            for (var i = 0; i < Response().length; i++) {
                if (i == 0)
                    profileId = Response()[i];
                else
                    profileId = profileId + "|" + Response()[i];
            }
            return profileId;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: MakePipeDelimited() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function AddQualitativeQuestion(data) {
        try {
            var riskQuestionObj = "";
            $('#valErrorQQ').hide();
            var selectedassessmetId = "";
            for (var i = 0; i < AMLQsViewModel.SelectedAssessmentTypeFactor().length; i++) {
                if (i == 0)
                    selectedassessmetId += selectedassessmetId + AMLQsViewModel.SelectedAssessmentTypeFactor()[i];
                else
                    selectedassessmetId += "|" + AMLQsViewModel.SelectedAssessmentTypeFactor()[i];
            }

            var selectedresponseIds = "";
            for (var i = 0; i < AMLQsViewModel.SelectedResponseTypeFactor().length; i++) {
                if (i == 0)
                    selectedresponseIds += selectedresponseIds + AMLQsViewModel.SelectedResponseTypeFactor()[i];
                else
                    selectedresponseIds += "|" + AMLQsViewModel.SelectedResponseTypeFactor()[i];
            }
            var RiskAreaId;

            RiskAreaId = AMLQsViewModel.CurrentSubRiskAreaId();
            AMLQsViewModel.QualQuestionRiskSubAreaSubList([]);
            for (var j = 0; j < AMLQsViewModel.SelectedLanguageFactorType().length; j++) {
                for (var i = 0; i < AMLQsViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(AMLQsViewModel.SelectedLanguageFactorType()[j]) == AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                        selectedItem = AMLQsViewModel.SelectedLanguageFactorType()[j];
                        riskQuestionObj = new RiskFactor(selectedItem);
                        //validate language text boxes
                        if (riskQuestionObj.RiskAreaName == "") {
                            $('#valErrorQQ').show();
                            $('#valErrorQQ').text('Risk Factor in ' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' is required.');
                            return;
                        } else {
                            $('#valErrorQQ').text('');
                        }
                        AMLQsViewModel.QualQuestionRiskSubAreaSubList.push(riskQuestionObj);
                    }
                }
            }
            if (AMLQsViewModel.SelectedLanguageFactorType().length == 0) {

                AMLQsViewModel.QualQuestionRiskSubAreaSubList([]);



            }
            var pipledelimited = MakePipeDelimited(AMLQsViewModel.selectedparentResponseId)
            AMLQsViewModel.ParentQuestionId($('#ParentQuestionDropDown').val());
            AMLQsViewModel.ParentResponseId(pipledelimited);
            var LanguageQuestionsList;
            LanguageQuestionsList = AMLQsViewModel.QualQuestionRiskSubAreaSubList();


            AMLQsViewModel.SelectedZATRATList([]);
            var MappedZATRATList = [];
            for (var j = 0; j < AMLQsViewModel.SelectedAssessmentTypeFactor().length; j++) {
                for (var k = 0; k < AMLQsViewModel.ZATRATList().length; k++) {
                    if (AMLQsViewModel.ZATRATList()[k].ZAT_UID() === AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId() &&
                        AMLQsViewModel.ZATRATList()[k].RAT_UID() === AMLQsViewModel.SelectedAssessmentTypeFactor()[j]) {
                        MappedZATRATList.push(new ZATRATModel(AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(), null, AMLQsViewModel.SelectedAssessmentTypeFactor()[j], null));
                    }
                }
            }

            AMLQsViewModel.SelectedZATRATList(MappedZATRATList);

            var MappedCopyOverAreas = "";
            for (var i = 0; i < AMLQsViewModel.SelectedCopyOverAreas().length; i++) {
                if (i == 0)
                    MappedCopyOverAreas += AMLQsViewModel.SelectedCopyOverAreas()[i];
                else
                    MappedCopyOverAreas += ',' + AMLQsViewModel.SelectedCopyOverAreas()[i];
            }
            if (data.MultiselectQuestion() === false)
                data.MultiselectQuestion(0);
            else
                data.MultiselectQuestion(1);

            if ($('#valErrorQQ').text() == "") {
                data.RiskAreaId = AMLQsViewModel.CurrentRiskAreaId();
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Qualitative/AddQualitativeQuestion",
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: ({
                        RiskAreaId: RiskAreaId,
                        AssessmentType: selectedassessmetId,
                        ResponseType: selectedresponseIds,
                        QuestionId: data.QuestionId(),
                        QuestionShortName: data.QuestionShortName(),
                        QuestionName: data.QuestionName(),
                        CalculationApplicability: data.CalculationApplicability(),
                        //MultiselectQuestion: data.MultiselectQuestion(),
                        RiskAreaSubList: LanguageQuestionsList,
                        ReadOnlyTypeFactor: AMLQsViewModel.FactorReadOnlyType(),
                        HeaderTypeFactor: AMLQsViewModel.FactorHeaderType(),
                        ConditionalTypeFactor: AMLQsViewModel.FactorConditionalType(),
                        ParentQuestionId: AMLQsViewModel.ParentQuestionId(),
                        ParentResponseId: AMLQsViewModel.ParentResponseId(),
                        CopyOverAreas: MappedCopyOverAreas,
                        ZATRATModelObj: AMLQsViewModel.SelectedZATRATList(),
                        HeaderUID: data.HeaderUID(),
                        QuestionGuideline: AMLQsViewModel.QuestionGuideline(),
                        ResponseOptionTypeModelObject: AMLQsViewModel.ResponseOptionList()
                        //OptionTypeShortName: AMLQsViewModel.selectedOptionType()

                    })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in AddQualitativeQuestion() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult.Flag == 1) {
                    AMLQsViewModel.CurrentSubRiskAreaId(RiskAreaId);


                    GetAllQuestionsQualitative();
                    logger.logSuccess('Qualitative Question added successfully.', 'Success', system.getModuleId(AMLQsViewModel), true);
                }
                else if (jsonResult.Flag == 2)
                    logger.logError('The Qualitative Question cannot be added/updated as it already exists.', 'Error', system.getModuleId(AMLQsViewModel), true);
                else if (jsonResult.Flag == 3)
                    logger.logError('Qualitative Question cannot be added/updated as it contain some invalid characters.', 'Error', system.getModuleId(AMLQsViewModel), true);
                else
                    logger.logError('An error occurred while adding the Qualitative Question.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in AddQualitativeQuestion() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in AddQualitativeQuestion() method in AMLQualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in AddQualitativeQuestion() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function EditQuestionPopUp(data, event) {
        try {
            AMLQsViewModel.LanguageddFactorVisible(false);
            AMLQsViewModel.CalculationCheckboxdisabled(true);
            AMLQsViewModel.MultiselectQuestionCheckboxdisabled(true);
            //AMLQsViewModel.selectedOptionType(data.OptionTypeShortName());
            AMLQsViewModel.ResponseOptionList(data.ResponseOptionTypeList);
            AMLQsViewModel.AssessmentTypeFactorDisabled(true);
            AMLQsViewModel.EditFactorVisible(true);
            AMLQsViewModel.EditQuestion(true);
            AMLQsViewModel.QuestionGuideline(data.QuestionGuideline());
            var Assessment = "";
            var AssessmentIds = [];
            var AssessmentIdsEdit = [];
            for (var k = 0; k < AMLQsViewModel.AssessmentTypeList().length; k++) {
                var countVar = 0;
                for (var f = 0; f < data.MappedAssessmentType().length; f++) {
                    if (parseInt(AMLQsViewModel.AssessmentTypeList()[k].AssessmentId()) == data.MappedAssessmentType()[f].ID) {
                        if (Assessment == "") {
                            Assessment += AMLQsViewModel.AssessmentTypeList()[k].AssessmentName();
                        }
                        else {
                            Assessment += ", " + AMLQsViewModel.AssessmentTypeList()[k].AssessmentName();
                        }
                        AssessmentIds.push(AMLQsViewModel.AssessmentTypeList()[k].AssessmentId());
                        countVar++;
                    }
                }
                if (countVar == 0) {
                    AssessmentIdsEdit.push(AMLQsViewModel.AssessmentTypeList()[k]);
                }
            }
            var NewDataObj = new QualitativeQuestionsModel({
                MappedAssessments: data.MappedAssessmentType(), AMLRank: data.AMLRank(), SANCRank: data.SANCRank(),
                QuestionId: data.QuestionId(), QuestionShortName: data.QuestionShortName(), QuestionName: data.QuestionName(),
                CalculationApplicability: data.CalculationApplicability(), MultiselectQuestion: data.MultiselectQuestion(), QuestionType: data.QuestionType(), Applicable: data.Applicable(),
                RiskAreaSubList: data.RiskAreaSubList(), ReadOnlyTypeFactor: data.ReadOnlyTypeFactor(), HeaderTypeFactor: data.HeaderTypeFactor(),
                ConditionalTypeFactor: data.ConditionalTypeFactor(), ParentQuestionId: data.ParentQuestionId(), ParentResponseId: data.ParentResponseId(),
                HeaderUID: data.HeaderUID(), CopyOverAreas: data.CopyOverAreas(), CopyOverAreasNames: data.CopyOverAreasNames()
            });
            AMLQsViewModel.QuestionPopUpData(NewDataObj);
            if (data.ReadOnlyTypeFactor() == true) {
                QuestionTypeText = "ReadOnlyTypeFactor";
            }
            else if (data.HeaderTypeFactor() == true) {
                QuestionTypeText = "HeaderTypeFactor";
            }
            else if (data.ConditionalTypeFactor() == true) {
                QuestionTypeText = "ConditionalTypeFactor";
            }

            //Add dynamic language inputs
            if (data.RiskAreaSubList() != null && data.RiskAreaSubList().length > 0) {
                AddDynamicFactorElements(data.RiskAreaSubList());

                $.each(data.RiskAreaSubList(), function (key, value) {
                    $('#questionname' + value.LanguageType.toString()).val(value.RiskAreaName);
                    $('#ScenariosFactorTextArea' + value.LanguageType.toString()).val(value.RiskAreaNotes);
                });
                $("#frmQualitativeQuestionsScroll").css({ "height": "auto", "max-height": "auto", "overflow-y": "auto", "overflow-x": "hidden" });
            } else {
                $('#frmQualitativeQuestionsScroll').removeAttr("style");
            }
            AMLQsViewModel.AssessmentTypeFactor(data.AssessmentType());
            AMLQsViewModel.QuestionPopUpType("Edit");
            AMLQsViewModel.QuestionPopUpTitle("Edit Qualitative Question");

            document.getElementById('questionapplicability').disabled = true;
            //document.getElementById('multiselectquestion').disabled = true;
            document.getElementById('EditFactorAssessment').innerHTML = Assessment;
            if (data.FactorType() === "" || data.FactorType() === null)
                document.getElementById('EditFactorResponse').innerHTML = data.ResponseType().replace('|', ', ');
            else
                $('#EditFactorResponseDiv').removeClass('d-flex').addClass("d-none").hide();
            //set parentQuestionId and parentresponseId to two dropdowns
            $("#ParentQuestionDropDown").val(data.ParentQuestionId());
            $("#ParentResponseDropDown").val(data.ParentResponseId());
            $("#ParentQuestionLabel").html($("#ParentQuestionDropDown :selected").text());
            AMLQsViewModel.SelectedCopyOverAreas([]);
            AMLQsViewModel.SelectedCopyOverAreasEdit(data.CopyOverAreas().split(','));
            AMLQsViewModel.SelectedAssessmentTypeFactor([]);
            AMLQsViewModel.SelectedAssessmentTypeFactorEdit(AssessmentIds);
            ApplicabilityRelEvents(data, event);
            AMLQsViewModel.FactorAssessmentTypeListEdit(AssessmentIdsEdit);
            $('#AreaApplicabilityDiv').empty();
            document.getElementById('AreaApplicabilityDiv').innerHTML = data.CopyOverAreasNames();

            if (AMLQsViewModel.FactorAssessmentTypeListEdit().length > 0) {
                $('#FactorAppTypeIDEdit').multiselect();
                $('#FactorAppTypeIDEdit').multiselect('refresh');
            }
            else {
                $('#FactorAppTypeIDEdit').hide();
            }

            $('#ResponseSubfactor').removeClass('d-flex').addClass("d-none").hide();
            $('#frmQualitativeQuestions').modal('show');
            //CKEDITOR.replace('QuestionGuideline');
            setTimeout("$('#questionname').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditQuestionPopUp() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function ConfigureInstructions() {
        AMLQsViewModel.Instructions('');
        GetInstructions().then(function () {
            $('#frmConfigureInstructions').modal('show');
        });
    }
    function GetInstructions() {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            getAllInstructions = {

                url: "/api/Configuration/GetInstructions",
                contentType: "application/json; charset=utf-8",
                type: "POST",
                headers: headers,
                data: ko.toJSON({
                    "AreaId": AMLQsViewModel.CurrentSubRiskAreaId(),
                    "AreaType": "INH",
                    "Type": "SB"
                }),
                headers: headers
            };
            return $.ajax(getAllInstructions)
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            let msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetInstructions() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
        function ajaxSuccess(jsonResult, status) {
            if (jsonResult !== null) {
                AMLQsViewModel.Instructions();
                AMLQsViewModel.Instructions(jsonResult.Instruction);
            }
        }
        function ajaxFail(error, status) {
            try {
                if (error.status === 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then((option) => {
                            if (option === "OK")
                                navigation.unauthorized();
                        });
                }
                else {
                    let msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetInstructions method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                let msg = 'Exception: ' + e + ' | Source: ajaxFail in GetInstructions method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }
    }
    function SaveInstructions() {
        try {
            //AMLQsViewModel.Instructions(CKEDITOR.instances["Instructions"].getData());
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveInstructions",
                headers: headers,
                type: "POST",
                applicationType: 'application/json',
                dataType: 'json',
                data: ({
                    "AreaId": AMLQsViewModel.CurrentSubRiskAreaId(),
                    "AreaType": "INH",
                    "Type": "SB",
                    "Instruction": AMLQsViewModel.Instructions()
                })
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in SaveInstructions() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                $('#frmConfigureInstructions').modal('hide');
                logger.logSuccess('Instructions are saved successfully.', 'Success', system.getModuleId(AMLQsViewModel), true);
                GetInstructions();
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in SaveInstructions() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {

            try {
                $('#frmConfigureInstructions').modal('hide');
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in SaveInstructions() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in SaveInstructions() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }
    function UpdateQualitativeQuestion(data) {
        try {

            data.RiskAreaId = AMLQsViewModel.CurrentSubRiskAreaId();
            if (data.RiskAreaSubList() != null && data.RiskAreaSubList().length > 0) {

                for (var i = 0; i < data.RiskAreaSubList().length; i++) {
                    data.RiskAreaSubList()[i].RiskAreaName = $('#questionname' + data.RiskAreaSubList()[i].LanguageType.toString()).val();
                    data.RiskAreaSubList()[i].RiskAreaNotes = $('#ScenariosFactorTextArea' + data.RiskAreaSubList()[i].LanguageType.toString()).val();
                    if (data.RiskAreaSubList()[i].RiskAreaName == "") {
                        $('#valErrorQQ').show();
                        $('#valErrorQQ').text('Risk Factor in ' + GetLanguageName(data.RiskAreaSubList()[i].LanguageType) + ' is required.');
                        return;
                    } else {
                        $('#valErrorQQ').text('');
                    }

                }
            }
            AMLQsViewModel.ParentQuestionId($('#ParentQuestionDropDown').val());
            AMLQsViewModel.ParentResponseId($('#ParentResponseDropDown').val());
            AMLQsViewModel.SelectedZATRATList([]);
            var MappedZATRATList = [];
            var AssessmentTypeIds = "";
            if (AMLQsViewModel.SelectedAssessmentTypeFactor() != undefined) {
                for (var j = 0; j < AMLQsViewModel.SelectedAssessmentTypeFactor().length; j++) {
                    for (var k = 0; k < AMLQsViewModel.ZATRATList().length; k++) {
                        if (AMLQsViewModel.ZATRATList()[k].ZAT_UID() === AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId() &&
                            AMLQsViewModel.ZATRATList()[k].RAT_UID() === AMLQsViewModel.SelectedAssessmentTypeFactor()[j]) {
                            MappedZATRATList.push(new ZATRATModel(AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(), null, AMLQsViewModel.SelectedAssessmentTypeFactor()[j], null));
                        }
                    }
                    if (AssessmentTypeIds === "")
                        AssessmentTypeIds += AMLQsViewModel.SelectedAssessmentTypeFactor()[j];
                    else
                        AssessmentTypeIds += "|" + AMLQsViewModel.SelectedAssessmentTypeFactor()[j];
                }
            }

            for (var j = 0; j < AMLQsViewModel.SelectedAssessmentTypeFactorEdit().length; j++) {
                for (var k = 0; k < AMLQsViewModel.ZATRATList().length; k++) {
                    if (AMLQsViewModel.ZATRATList()[k].ZAT_UID() === AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId() &&
                        AMLQsViewModel.ZATRATList()[k].RAT_UID() === AMLQsViewModel.SelectedAssessmentTypeFactorEdit()[j]) {
                        MappedZATRATList.push(new ZATRATModel(AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(), null, AMLQsViewModel.SelectedAssessmentTypeFactorEdit()[j], null));
                    }
                }
                if (AssessmentTypeIds === "")
                    AssessmentTypeIds += AMLQsViewModel.SelectedAssessmentTypeFactorEdit()[j];
                else
                    AssessmentTypeIds += "|" + AMLQsViewModel.SelectedAssessmentTypeFactorEdit()[j];
            }
            AMLQsViewModel.SelectedZATRATList(MappedZATRATList);


            data.AssessmentType = AssessmentTypeIds;
            var MappedCopyOverAreas = "";
            var ArrayCopyOverAreas = data.CopyOverAreas().split(',');
            for (var i = 0; i < ArrayCopyOverAreas.length; i++) {
                if (ArrayCopyOverAreas[i] != data.RiskAreaId) {
                    if (MappedCopyOverAreas == "")
                        MappedCopyOverAreas += MappedCopyOverAreas + ArrayCopyOverAreas[i];
                    else
                        MappedCopyOverAreas += "," + ArrayCopyOverAreas[i];
                }
            }

            if (AMLQsViewModel.SelectedCopyOverAreas() != undefined) {
                for (var i = 0; i < AMLQsViewModel.SelectedCopyOverAreas().length; i++) {
                    if (MappedCopyOverAreas == "")
                        MappedCopyOverAreas += AMLQsViewModel.SelectedCopyOverAreas()[i];
                    else
                        MappedCopyOverAreas += ',' + AMLQsViewModel.SelectedCopyOverAreas()[i];
                }
            }

            if ($('#valErrorQQ').text() == "") {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Qualitative/UpdateQualitativeQuestion",
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: ({
                        RiskAreaId: data.RiskAreaId,
                        AssessmentType: data.AssessmentType,
                        QuestionId: data.QuestionId(),
                        QuestionShortName: data.QuestionShortName(),
                        QuestionName: data.QuestionName(),
                        CalculationApplicability: data.CalculationApplicability(),
                        //MultiselectQuestion: data.MultiselectQuestion(),
                        RiskAreaSubList: data.RiskAreaSubList(),
                        ReadOnlyTypeFactor: AMLQsViewModel.FactorReadOnlyType(),
                        HeaderTypeFactor: AMLQsViewModel.FactorHeaderType(),
                        ConditionalTypeFactor: AMLQsViewModel.FactorConditionalType(),
                        ParentQuestionId: AMLQsViewModel.ParentQuestionId(),
                        ParentResponseId: AMLQsViewModel.ParentResponseId(),
                        CopyOverAreas: MappedCopyOverAreas,
                        ZATRATModelObj: AMLQsViewModel.SelectedZATRATList(),
                        HeaderUID: data.HeaderUID(),
                        QuestionGuideline: AMLQsViewModel.QuestionGuideline()
                        //OptionTypeShortName: AMLQsViewModel.selectedOptionType()
                    })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateQualitativeQuestion() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult == 1) {
                    GetAllQuestionsQualitative();

                    //getall
                    logger.logSuccess('Qualitative Question updated successfully.', 'Success', system.getModuleId(AMLQsViewModel), true);
                }
                else if (jsonResult == 2)
                    logger.logError('The Qualitative Question you are trying to update does not exist. Please refresh the page and try again.', 'Error', system.getModuleId(AMLQsViewModel), true);
                else
                    logger.logError('An error occurred while updating Qualitative Question.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UpdateQualitativeQuestion() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateQualitativeQuestion() method in AMLQualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateQualitativeQuestion() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function DeleteQuestionPopUp(data, event) {
        try {
            app.showMessage('Are you sure you want to delete this Qualitative Question?', 'Delete Qualitative Question', ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash-o text-default' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        DeleteQualitativeQuestion(data);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DeleteQuestionPopUp() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function DeleteQualitativeQuestion(data) {
        try {
            var ClickedAreaId = AMLQsViewModel.CurrentSubRiskAreaId();

            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Qualitative/DeleteQualitativeQuestion?AreaId=" + ClickedAreaId +
                    "&SurveyCategoryId=" + AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(),
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    QuestionId: data.QuestionId()
                }),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteQualitativeQuestion() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult == 1) {
                    var RowIndex = 0;
                    for (var i = 0; i < AMLQsViewModel.QuestionsList().length; i++) {
                        if (AMLQsViewModel.QuestionsList()[i].QuestionId() == data.QuestionId()) {
                            RowIndex = i;
                        }
                    }
                    QuestionTableObj.row(RowIndex).remove().draw(false);
                    AMLQsViewModel.QuestionsList().splice(RowIndex, 1);
                    GetAllQuestionsQualitative();
                    logger.logSuccess('Qualitative Question deleted successfully .', 'Success', system.getModuleId(AMLQsViewModel), true);
                }
                else if (jsonResult == 2)
                    logger.logError('No such Qualitative Question exists. Please refresh the page and try again.', 'Error', system.getModuleId(AMLQsViewModel), true);
                else
                    logger.logError('An error occurred while deleting the Qualitative Question.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteQualitativeQuestion() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteQualitativeQuestion() method in AMLQualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteQualitativeQuestion() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function SaveQuestionPopUpBtn(data, event) {
        try {
            //AMLQsViewModel.QuestionGuideline(CKEDITOR.instances["QuestionGuideline"].getData());

            if (ValidateQuestion(data)) {

                if (AMLQsViewModel.QuestionPopUpType() == "Add")
                    AddQualitativeQuestion(data);
                else
                    UpdateQualitativeQuestion(data);

                if ($('#valErrorQQ').text() == "") {
                    $('#frmQualitativeQuestions').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveQuestionPopUpBtn() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function ValidateQuestion(data) {
        try {
            var RowIndex = -1;
            var DuplicateShortName = 0;
            var DuplicateName = 0;
            var Result = false;

            if (data.QuestionShortName() == "" || data.QuestionShortName() == undefined || data.QuestionShortName() == null) {
                $('#valErrorQQ').text("Question Name cannot be left blank.");
                $('#valErrorQQ').show();
            }

            else if (data.QuestionName() == "" || data.QuestionName() == undefined || data.QuestionName() == null) {
                $('#valErrorQQ').text("Question cannot be left blank.");
                $('#valErrorQQ').show();
            }
            else if (AMLQsViewModel.QuestionGuideline().length > 4000) {
                $('#valErrorQQ').show();
                $('#valErrorQQ').text('Question Guideline cannot exceed 4000 characters. Please enter a valid Guideline.');

            }
            else if (AMLQsViewModel.EditQuestion() != true) {

                if (AMLQsViewModel.SelectedAssessmentTypeFactor() == undefined || AMLQsViewModel.SelectedAssessmentTypeFactor() == "" || AMLQsViewModel.SelectedAssessmentTypeFactor().length < 1) {
                    $('#valErrorQQ').text("Applicability cannot be left blank.");
                    $('#valErrorQQ').show();
                }
                else if (AMLQsViewModel.FactorHeaderType() == false && (AMLQsViewModel.SelectedResponseTypeFactor() == undefined || AMLQsViewModel.SelectedResponseTypeFactor() == "" || AMLQsViewModel.SelectedResponseTypeFactor().length < 1)) {
                    $('#valErrorQQ').text("Response Type cannot be left blank.");
                    $('#valErrorQQ').show();
                } else {
                    Result = true;
                    $('#valErrorQQ').text("");
                    $('#valErrorQQ').hide();
                }
            }

            else {
                $('#valErrorQQ').text("");
                $('#valErrorQQ').hide();
                Result = true;
            }
            return Result;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ValidateQuestion() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    //-------------------------------------------------------Logic Related to Qualitative Questions Ends Here---------------------------------------------------------------------------

    //-------------------------------------------------------Logic Related to Expand/Collapse of Questions Table Row Starts Here-------------------------------------------------------
    function RowExpandClick(data, event) {
        try {
            if (data.CalculationApplicability() == true || (data.MultiselectQuestion() == 1 && data.CalculationApplicability() == false)) {
                AMLQsViewModel.AssessmentTypeFactor(data.AssessmentType());
                var tr = $(event.currentTarget).closest('tr');
                var row = QuestionTableObj.row(tr);
                AMLQsViewModel.SelectedResponseRow([]);
                AMLQsViewModel.SelectedResponseRow.push(tr);
                AMLQsViewModel.SelectedResponseRow.push(data);
                CheckExpandedRow(row, false);
                if (row.child.isShown()) {
                    //close the open row
                    row.child.hide();
                    tr.removeClass('shown');
                    ResponseTableObj = false;
                }
                else {
                    // Open this row
                    GetQuestionResponse(data).then(function () {
                        ResposneTable(AMLQsViewModel.SelectedResponseRow());
                    })

                }
            }
            else {
                app.showMessage("This particular factor can not have specific responses.", "Respones not applicable.", ["OK"], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK") { }
                    })
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RowExpandClick() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function ResposneTable(param) {
        var tr = param[0]
        var row = QuestionTableObj.row(tr);
        row.child("");
        row.child(format(row.data())).show();
        tr.addClass('shown');
        ko.applyBindingsToNode($('#tblQuestionResponse tbody').get(0), { foreach: AMLQsViewModel.QuestionResponsesList() }, AMLQsViewModel);
        //if (AMLQsViewModel.ControlsAccess())
        //    ko.applyBindingsToNode($('#btnAddResponse').get(0), { click: AMLQsViewModel.AddResponsePopUp }, param[1]);
        ResponseTableObj = $('#tblQuestionResponse').DataTable({
            "bResponsive": true,
            "bPaginate": true,

            "order": [4, "asc"],
            "aaSorting": [],
            "aoColumnDefs": [{
                "aTargets": [0],
                "bVisible": false
            }, {
                "aTargets": [1],
                "bSortable": true
            }, {
                "aTargets": [6],
                "bSortable": false,
                "sClass": "text-center",
                "bVisible": (AMLQsViewModel.ControlsAccess()) ? true : false
            }]
        })

    }
    function CheckExpandedRow(row, isPaginating) {
        try {
            var currentRowIndex;
            var rowsInTable = $('#tblQualQuestions').find('tr');
            if (isPaginating)
                currentRowIndex = -1;
            else
                currentRowIndex = row.index();
            var info = QuestionTableObj.page.info();
            for (var i = 1, j = (rowsInTable.length); i < j; i++) {
                var tr = $('#tblQualQuestions').find('tr').get(i);
                if (QuestionTableObj.row(tr).index() != currentRowIndex) {
                    var tableRowIndex = 0;
                    if (isPaginating)
                        tableRowIndex = (AMLQsViewModel.CurrentPageNumber() * info.length) + (i - 1);
                    else
                        tableRowIndex = (info.page * info.length) + (i - 1);
                    if ((QuestionTableObj.row(tableRowIndex).child() != undefined) && (QuestionTableObj.row(tableRowIndex).child.isShown())) {
                        QuestionTableObj.row(tableRowIndex).child.remove();
                        tr.removeAttribute('class', 'shown');
                        j = $('#tblQualQuestions').find('tr').length;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CheckExpandedRow() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function format(data) {
        try {


            var ResponseHtml = '<div class="child-active">' +
                '<div class="panel panel-success panel-margin">' +
                '<div class="panel-heading">' +
                '<h5 class="panel-title riskFactorCellPanel">Responses';
            ResponseHtml += '</h5>' +
                '</div>' +
                '</div>' +
                '<div class="subfactor-margin">' +
                '<table id="tblQuestionResponse" class="dataTable table-bordered" cellspacing="0">' +
                '<thead>' +
                '<tr>' +
                '<th style="display:none">Response ID</th>' +
                '<th class="col-width-12">'

            ResponseHtml += (!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SequentialOrderNumber') == -1) ? 'Sequential Order Number' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('SequentialOrderNumber')].Name();
            //ResponseHtml += Sequential Order Number
            ResponseHtml += '</th > ' +
                '<th class="col-width-50">';

            //Response
            ResponseHtml += (!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Response') == -1) ? 'Response' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Response')].Name();
            ResponseHtml += '</th > ' +
                '<th>';

            //Assessment Type
            ResponseHtml += (!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentType') == -1) ? 'Assessment Type' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('AssessmentType')].Name();
            ResponseHtml += '</th > ' +
                '<th>';

            //Response Type
            ResponseHtml += (!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseType') == -1) ? 'ResponseType' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseType')].Name();
            ResponseHtml += '</th > ' +
                '<th class="col-width-10">';
            //Risk Score
            ResponseHtml += (!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskScore') == -1) ? 'Risk Score' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('RiskScore')].Name();
            ResponseHtml += '</th > ' +
                '<th class="actions">';
            //Actions;
            ResponseHtml += (!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions') == -1) ? 'Actions' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Actions')].Name();

            ResponseHtml += '</th > ' +
                '</tr>' +
                '</thead>' +
                '<tbody data-bind="foreach: QuestionResponsesList">' +
                '<tr>' +
                '<td style="display:none" data-bind="text: ResponseId"></td>' +
                '<td data-bind="text: SeqOrderNum"></td>' +
                '<td data-bind="text: Response"></td>' +
                '<td data-bind="text: AssessmentType"></td>' +
                '<td data-bind="text: ResponseType"></td>' +
                '<td data-bind="text: RiskLevel"></td>' +
                '<td class="text-center">' +
                '<a href="javascript:void(0)" title="Edit Response" class="btn-borderless widget-button" data-bind="click: $root.EditResponsePopUp">' +
                '<i class="demo-icon icon-file_edit_special"></i>' +
                '</a>' +
                '</td>' +
                '</tr>' +
                '</tbody>' +
                '</table>' +
                '</div>' +
                '<div>';

            return ResponseHtml;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: Format() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------Logic Related to Expand/Collapse of Questions Table Row Ends Here----------------------------------------------------------


    //-------------------------------------------------------Logic Related to Question's Response Starts Here---------------------------------------------------------------------------
    function GetQuestionResponse(data) {
        try {
            var QuesId = data.QuestionId();

            var CurrentAreaId = parseInt(AMLQsViewModel.CurrentSubRiskAreaId());
            return $.ajax({
                url: "/api/Visualization/GetQuestionResponse",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: {
                    "QuestionId": QuesId,
                    "SurveyCategoryID": AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(),
                    "AssessmentTypes": AMLQsViewModel.InherentSetupQualObj().data.AssessmentTypeId(),
                    "CurrentAreaId": CurrentAreaId, "ScenarioId": AMLQsViewModel.SelectedScenarioId()
                }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetQuestionResponse() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                AMLQsViewModel.QuestionResponsesList([]);
                if (jsonResult != null && jsonResult.length > 0) {
                    AMLQsViewModel.QuestionResponsesList([]);
                    var MappedQuestionResponses = $.map(jsonResult, function (result) {
                        return new QuestionResponseModel(result);
                    })
                    AMLQsViewModel.QuestionResponsesList(MappedQuestionResponses);

                }
                else if (jsonResult == null)
                    logger.logError('An error occurred while fetching the responses for this question.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQuestionResponse() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionResponse() method in AMLQualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionResponse() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function AddResponsePopUp(data, event) {
        try {
            AMLQsViewModel.SelectedLanguageSubFactorType([]);
            AMLQsViewModel.SubFactorRiskAreaList([]);
            AMLQsViewModel.SelectedAssessmentTypeSubFactor([]);
            AMLQsViewModel.SelectedResponseTypeSubFactor([]);
            AMLQsViewModel.copyOverResponse(false);
            var posOfQues;
            for (var s = 0; s < AMLQsViewModel.QuestionsList().length; s++) {
                if (parseInt(AMLQsViewModel.QuestionsList()[s].QuestionId()) == parseInt(data.QuestionId())) {
                    AMLQsViewModel.CurrentRiskQuestionType(AMLQsViewModel.QuestionsList()[s].MappedAssessmentType());
                    AMLQsViewModel.CurrentRiskQuestionResponseType(AMLQsViewModel.QuestionsList()[s].MappedResponseType());
                    posOfQues = s;
                    break;
                }
            }

            var mappedassessment = $.map(AMLQsViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < AMLQsViewModel.CurrentRiskQuestionType().length; i++) {
                    if (AMLQsViewModel.CurrentRiskQuestionType()[i].ID == parseInt(result.AssessmentId())) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });

            var mappedResponseTypeList = $.map(AMLQsViewModel.ResponseTypeList(), function (result) {
                for (var i = 0; i < AMLQsViewModel.CurrentRiskQuestionResponseType().length; i++) {
                    if (AMLQsViewModel.CurrentRiskQuestionResponseType()[i] == parseInt(result.RESPONSE_ID)) {
                        for (var m = 0; m < AMLQsViewModel.QuestionsList()[posOfQues].ResponseOptionTypeList.length; m++) {
                            if (AMLQsViewModel.QuestionsList()[posOfQues].ResponseOptionTypeList[m].ResponseTypeId() == result.RESPONSE_ID
                                && AMLQsViewModel.QuestionsList()[posOfQues].ResponseOptionTypeList[m].OptionTypeShortName() != 'R'
                                && AMLQsViewModel.QuestionsList()[posOfQues].ResponseOptionTypeList[m].OptionTypeShortName() != 'T') {

                                return result;
                            }

                        }

                    }
                }

            });
            $('#SubFactorApplicabilityDiv').remove();
            AMLQsViewModel.SubFactorAssessmentTypeList(mappedassessment);
            AMLQsViewModel.SubFactorResponseTypeList(mappedResponseTypeList);
            if (data.CalculationApplicability() == true || (data.MultiselectQuestion() == 1 && data.CalculationApplicability() == false)) {
                AMLQsViewModel.LanguageddFactorVisible(true);
                if (AMLQsViewModel.ObjGeneralSettings.LanguageList().length == 0) {
                    AMLQsViewModel.ObjGeneralSettings.getLanguages();
                }
                AMLQsViewModel.LanguageList = AMLQsViewModel.ObjGeneralSettings.LanguageList();
                if (AMLQsViewModel.LanguageList[0].LANGUAGE_ID._latestValue == 1) {
                    AMLQsViewModel.LanguageList.splice(0, 1);
                }
                AMLQsViewModel.SelectedLanguageSubFactorType([]);
                AMLQsViewModel.SubFactorRiskAreaList([]);
                AMLQsViewModel.valueAML('');
                AMLQsViewModel.valueSANC('');
                AMLQsViewModel.AssessmentTypeFactor(data.AssessmentType());
                ShowRiskLevels();
                var NewData = new QuestionResponseModel({ ResponseId: 0, QuestionId: data.QuestionId(), Response: "", RiskLevelId: 0, RiskLevel: "NA", AMLRiskLevel: "NA", SANCRiskLevel: "NA", RiskAreaSubList: new RiskAreaSubFactor({ RiskAreaName: "", LanguageType: "" }) });
                AMLQsViewModel.ResponsePopUpData(NewData);
                AMLQsViewModel.ResponsePopUpTitle("Add Response");
                AMLQsViewModel.ResponsePopUpType("Add");
                $('#appSubfactorEdit').removeClass('d-flex').addClass('d-none').hide();
                $('#frmQualitativeResponse').modal('show');

                $('#SubFactorAppTypeID').multiselect();
                $('#SubFactorAppTypeIDModified').multiselect();
                $('#SubFactorAppTypeIDModified').multiselect('refresh');
                $('#SubFactorResponseTypeID').multiselect();
                $('#SubFactorAppTypeID').multiselect('refresh');
                $('#SubFactorResponseTypeID').multiselect('refresh');
                $('#SubFactorApplicabilityDiv').hide();
                $('#RASubFactorLanguage').multiselect();
                setTimeout("$('#sequentialorderinput').focus();", 200);
            }
            else {
                app.showMessage("This particular factor can not have specific responses.", "Respones not applicable.", ["OK"], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", popupIcon: 'title-icon col-md-1 fa fa-login' })
                    .then(function (option) {
                        if (option == "OK") { }
                    })
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AddResponsePopUp() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function AddQuestionResponse(data) {
        try {
            var selectedassessmetId = "";
            var riskAreaSubFactorObj = "";
            var CurrentAreaId = parseInt(AMLQsViewModel.CurrentRiskAreaId());
            $('#valErrorQR').hide();

            CurrentAreaId = parseInt(AMLQsViewModel.CurrentSubRiskAreaId());
            for (var i = 0; i < AMLQsViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                if (i == 0)
                    selectedassessmetId += $('#' + AMLQsViewModel.SelectedAssessmentTypeSubFactor()[i] + 'AddScore').val() + ',' + selectedassessmetId + AMLQsViewModel.SelectedAssessmentTypeSubFactor()[i];
                else
                    selectedassessmetId += "|" + $('#' + AMLQsViewModel.SelectedAssessmentTypeSubFactor()[i] + 'AddScore').val() + ',' + AMLQsViewModel.SelectedAssessmentTypeSubFactor()[i];
            }
            for (var j = 0; j < AMLQsViewModel.SelectedLanguageSubFactorType().length; j++) {
                for (var i = 0; i < AMLQsViewModel.ObjGeneralSettings.LanguageList().length; i++) {
                    if (parseInt(AMLQsViewModel.SelectedLanguageSubFactorType()[j]) == AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID._latestValue) {
                        selectedItem = AMLQsViewModel.SelectedLanguageSubFactorType()[j];
                        riskAreaSubFactorObj = new RiskAreaSubFactor(selectedItem);
                        //validate language text boxes
                        if (riskAreaSubFactorObj.RiskAreaName == "") {
                            $('#valErrorQR').show();
                            $('#valErrorQR').text('Response in ' + AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME() + ' is required.');
                            return;
                        } else {
                            $('#valErrorQR').text('');
                        }
                        AMLQsViewModel.SubFactorRiskAreaList.push(riskAreaSubFactorObj);
                    }
                }
            }
            if ($('#valErrorQR').text() == "") {
                var respType = AMLQsViewModel.SelectedResponseTypeSubFactor().join('|');
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Qualitative/AddQuestionResponse?AssessmentType=" + AMLQsViewModel.AssessmentTypeFactor()
                        + "&SurveyCategoryId=" + AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId()
                        + "&CurrentAreaId=" + CurrentAreaId
                        + "&copyOverResponse=" + AMLQsViewModel.copyOverResponse(),
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: ({
                        ResponseId: data.ResponseId(),
                        QuestionId: data.QuestionId(),
                        Response: data.Response(),
                        ResponseType: respType,
                        MappedID: selectedassessmetId,
                        SeqOrderNum: data.SeqOrderNum(),
                        RiskAreaSubList: AMLQsViewModel.SubFactorRiskAreaList()
                    })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in AddQuestionResponse() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult.Flag == 1) {
                    GetQuestionResponse(data).then(function () {
                        ResposneTable(AMLQsViewModel.SelectedResponseRow());
                    })
                    logger.logSuccess(
                        //'Response added successfully.'
                        ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Responseaddsuccess') == -1) ? 'Response added successfully.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Responseaddsuccess')].Name)
                        , 'Success', system.getModuleId(AMLQsViewModel), true);
                }
                else if (jsonResult.Flag == 2)
                    logger.logError(
                        //'The Response that you are trying to add already exists.'
                        ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Responsealreadyexists') == -1) ? 'The Response that you are trying to add already exists.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('Responsealreadyexists')].Name)
                        , 'Error', system.getModuleId(AMLQsViewModel), true);
                else
                    logger.logError('An error occurred while adding the Response. Please contact the Administrator.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in AddQuestionResponse() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in AddQuestionResponse() method in AMLQualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in AddQuestionResponse() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function EditResponsePopUp(data, event) {
        try {
            AMLQsViewModel.SelectedAssessmentTypeSubFactor([]);
            AMLQsViewModel.SubFactorAssessmentTypeList([]);

            var selectedATIds = data.RiskMapping().split('|');
            for (var i = 0; i < selectedATIds.length; i++) {
                selectedATIds[i] = selectedATIds[i].split(',')[0].trim();
            }
            AMLQsViewModel.SelectedAssessmentTypeSubFactorEdit(selectedATIds);
            AMLQsViewModel.LanguageddFactorVisible(false);
            var NewData = new QuestionResponseModel({
                ResponseId: data.ResponseId(), QuestionId: data.QuestionId(),
                Response: data.Response(), SeqOrderNum: data.SeqOrderNum(), RiskMapping: data.RiskMapping(), AssessmentType: data.AssessmentType(), RiskAreaSubList: data.RiskAreaSubList()
            });
            // ShowRiskLevels();
            AMLQsViewModel.ResponsePopUpData(NewData);
            var mappedassessment = $.map(AMLQsViewModel.AssessmentTypeList(), function (result) {
                for (var i = 0; i < AMLQsViewModel.SelectedResponseRow()[1].MappedAssessmentType().length; i++) {
                    if (AMLQsViewModel.SelectedResponseRow()[1].MappedAssessmentType()[i].ID == parseInt(result.AssessmentId()) &&
                        AMLQsViewModel.SelectedAssessmentTypeSubFactorEdit().indexOf(AMLQsViewModel.AssessmentTypeList()[i].AssessmentId()) < 0) {
                        var RiskAreaModelObj = new FilteredAssessmentListModel(result);
                        return RiskAreaModelObj;
                    }
                }

            });
            AMLQsViewModel.SubFactorAssessmentTypeList(mappedassessment);
            $('#appSubfactor').removeClass('d-flex').addClass('d-none').hide();
            if (AMLQsViewModel.SelectedAssessmentTypeSubFactorEdit().length === AMLQsViewModel.SelectedResponseRow()[1].MappedAssessmentType().length) {
                $('#SubFactorAppTypeIDModified').removeClass('d-flex').addClass('d-none').hide();
            }
            else {
                $('#SubFactorAppTypeIDModified').show();
                $("#SubFactorAppTypeIDModified").multiselect();
                $('#SubFactorAppTypeIDModified').multiselect('refresh');
            }
            $('#SubFactorApplicabilityDiv').empty();
            document.getElementById('SubFactorApplicabilityDiv').innerHTML = data.AssessmentType();



            AMLQsViewModel.ResponsePopUpTitle(
                //"Edit Response - "
                    ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditResponse-') == -1) ? 'Edit Response - ' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('EditResponse-')].Name())
                + data.Response());
            AMLQsViewModel.ResponsePopUpType("Edit");
            $("#ResponseSubfactor").removeClass('d-flex').addClass("d-none").hide();
            $('#frmQualitativeResponse').modal('show');
            $('#SubFactorResponseTypeID').multiselect();
            $('#SubFactorResponseTypeID').multiselect('refresh');
            BindDynamicHtmlForDropDownsEdit(data.RiskMapping().split('|'));
            setTimeout("$('#sequentialorderinput').focus();", 200);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: EditResponsePopUp() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function BindDynamicHtmlForDropDownsEdit(data) {
        try {
            var DynamicHTMl = "";
            var arr = [];
            for (var k = 0; k < data.length; k++) {
                var splitID = data[k].split(',');

                for (var g = 0; g < AMLQsViewModel.AssessmentTypeList().length; g++) {

                    if (parseInt(splitID[0]) == AMLQsViewModel.AssessmentTypeList()[g].AssessmentId()) {

                        DynamicHTMl += '<div class="form-group d-flex" id="appSubfactor_RiskLevel">' +
                            '<label class="col-lg-2 control-label">' + AMLQsViewModel.AssessmentTypeList()[g].AssessmentName() + ' Risk Score:</label>' +
                            '<div class="col-sm-6 col-md-6 col-lg-6 mr-5">' +
                            '<select id="' + AMLQsViewModel.AssessmentTypeList()[g].AssessmentId() + 'EditScore" data-bind="foreach:{data: InherentRiskLevelList, as: \'List1\'}" class="form-control">' +
                            '<!-- ko if: (List1.AssessmentTypeId ==' + splitID[0] + '|| List1.AssessmentTypeId == 99999)-->' +
                            '<!-- ko if: !(List1.isQuantitative ==1)-->' +
                            '<optgroup data-bind="attr: {label: RiskLevelName}, foreach: MappedRiskLevels">' +
                            '<option data-bind="text: RiskLevelDescription,value:RiskLevelId"></option>' +
                            '</optgroup>' +
                            '<!--/ko -->' +
                            '<!--/ko -->' +
                            '</select>' +

                            '</div>' +
                            '</div>';

                    }
                }
            }
            document.getElementById('DynamicScoreDiv').innerHTML = DynamicHTMl
            ko.cleanNode(document.getElementById('DynamicScoreDiv'));
            ko.applyBindings(AMLQsViewModel, document.getElementById("DynamicScoreDiv"));
            for (var k = 0; k < data.length; k++) {
                var splitIDMap = data[k].split(',');
                if (splitIDMap[1] !== undefined)
                    $('#' + parseInt(splitIDMap[0]) + 'EditScore').val(parseInt(splitIDMap[1]));
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: BindDynamicHtmlForDropDownsEdit() method in RiskArea&Factor.js';
            logger.logMessage(msg);
        }
    }
    function UpdateQuestionResponse(data) {
        try {
            var RiskMapping = "";
            RiskMapping = data.RiskMapping();
            for (var i = 0; i < AMLQsViewModel.SelectedAssessmentTypeSubFactor().length; i++) {
                RiskMapping += "|" + AMLQsViewModel.SelectedAssessmentTypeSubFactor()[i] + "," + $('#' + AMLQsViewModel.SelectedAssessmentTypeSubFactor()[i] + "EditScore").val();
            }
            data.RiskMapping(RiskMapping);
            RiskMapping = "";
            for (var i = 0; i < data.RiskMapping().split('|').length; i++) {
                for (var j = 0; j < AMLQsViewModel.AssessmentTypeList().length; j++) {
                    if (AMLQsViewModel.AssessmentTypeList()[j].AssessmentId() == data.RiskMapping().split('|')[i].split(',')[0]) {
                        if (i == 0)
                            RiskMapping += data.RiskMapping().split('|')[i].split(',')[0] + ',' + $('#' + data.RiskMapping().split('|')[i].split(',')[0] + 'EditScore').val();
                        else
                            RiskMapping += "|" + data.RiskMapping().split('|')[i].split(',')[0] + ',' + $('#' + data.RiskMapping().split('|')[i].split(',')[0] + 'EditScore').val();
                    }
                }
            }
            if (data.RiskAreaSubList() != null && data.RiskAreaSubList().length > 0) {
                for (var i = 0; i < data.RiskAreaSubList().length; i++) {
                    data.RiskAreaSubList()[i].RiskAreaName = $('#response' + data.RiskAreaSubList()[i].LanguageType.toString()).val();
                    if (data.RiskAreaSubList()[i].RiskAreaName == "") {
                        $('#valErrorQR').show();
                        $('#valErrorQR').text('Response in ' + GetLanguageName(data.RiskAreaSubList()[i].LanguageType) + ' is required.');
                        return;
                    } else {
                        $('#valErrorQR').text('');
                    }
                }
            }
            if ($('#valErrorQR').text() == "") {
                var csrfToken = $("input[name='__RequestVerificationToken']").val();
                var headers = appsecurity.getSecurityHeaders();
                headers.__RequestVerificationToken = csrfToken;
                $.ajax({
                    url: "/api/Visualization/UpdateQuestionResponse",
                    headers: headers,
                    type: "POST",
                    applicationType: 'application/json',
                    dataType: 'json',
                    data: ({
                        ResponseId: data.ResponseId(),
                        QuestionId: data.QuestionId(),
                        Response: data.Response(),
                        MappedID: RiskMapping,
                        SeqOrderNum: data.SeqOrderNum(),
                        RiskAreaSubList: data.RiskAreaSubList(),
                        ScenarioId: AMLQsViewModel.SelectedScenarioId()
                    })
                })
                    .success(ajaxSuccess)
                    .fail(ajaxFail);
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in UpdateQuestionResponse() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult == 1) {
                    GetQuestionResponse(data).then(function () {
                        ResposneTable(AMLQsViewModel.SelectedResponseRow());
                    })

                    logger.logSuccess(
                        //'Response updated successfully .'
                        ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseUpdateSuccess') == -1) ? 'Response updated successfully .' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseUpdateSuccess')].Name)
                        , 'Success', system.getModuleId(AMLQsViewModel), true);
                }
                else if (jsonResult == 2)
                    logger.logError(
                        //'The Response that you are trying to update does not exist. Please refresh the page and try again.'
                        ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseDoesNotExist') == -1) ? 'The Response that you are trying to update does not exist. Please refresh the page and try again.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseDoesNotExist')].Name)
                        , 'Error', system.getModuleId(AMLQsViewModel), true);
                else
                    logger.logError(
                        //'An error occurred while updating the Response. Please contact the Administrator.'
                        ((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseUpdateError') == -1) ? 'An error occurred while updating the Response. Please contact the Administrator.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('ResponseUpdateError')].Name)
                        , 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in UpdateQuestionResponse() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in UpdateQuestionResponse() method in AMLQualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in UpdateQuestionResponse() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function DeleteResponsePopUp(data, event) {
        try {
            app.showMessage('Are you sure you want to delete this Response?', 'Delete Response - ' + data.Response(), ['Confirm', 'Cancel'], false, { primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "fa fa-times btn btn-default", "class": "modal-content custom-delete-response-1 messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-trash-o text-default' })
                .then(function (option) {
                    if (option === 'Confirm') {
                        DeleteQuestionResponse(data);
                    }
                });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DeleteResponsePopUp() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function DeleteQuestionResponse(data) {
        try {
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Qualitative/DeleteQuestionResponse",
                dataType: "json",
                contentType: "application/json; charset=utf-8",
                data: ko.toJSON({
                    ResponseId: data.ResponseId()
                }),
                headers: headers,
                type: "POST"
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in DeleteQuestionResponse() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                if (jsonResult == 1) {
                    var RowIndex = 0;
                    for (var i = 0; i < AMLQsViewModel.QuestionResponsesList().length; i++) {
                        if (AMLQsViewModel.QuestionResponsesList()[i].ResponseId() == data.ResponseId()) {
                            RowIndex = i;
                        }
                    }
                    ResponseTableObj.row(RowIndex).remove().draw(false);
                    AMLQsViewModel.QuestionResponsesList().splice(RowIndex, 1);
                    logger.logSuccess('Response deleted successfully .', 'Success', system.getModuleId(AMLQsViewModel), true);
                }
                else if (jsonResult == 2)
                    logger.logError('No such Response exists. Please refresh and try again.', 'Error', system.getModuleId(AMLQsViewModel), true);
                else
                    logger.logError('An error occurred while deleting the Response. Please contact the Administrator', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in DeleteQuestionResponse() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in DeleteQuestionResponse() method in AMLQualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in DeleteQuestionResponse() method in AMLQualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function SaveResponsePopUpBtn(data, event) {
        try {
            if (ValidateResponse(data)) {
                if (AMLQsViewModel.ResponsePopUpType() != "Add")
                    UpdateQuestionResponse(data);

                if ($('#valErrorQR').text() == "") {
                    $('#frmQualitativeResponse').modal('hide');
                    $('body').removeClass('modal-open');
                    $('.modal-backdrop').remove();
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveResponsePopUp() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function ValidateResponse(data) {
        try {
            var DuplicateCount = 0;
            var RowIndex = -1;
            var Result = false;
            var Flag = true;
            var SeqNum = data.SeqOrderNum();

            if (!isInt(data.SeqOrderNum())) {
                $('#valErrorQR').text("Sequence Order Number should be a number.");
                $('#valErrorQR').show();
            }
            else if (data.SeqOrderNum() == "" || data.SeqOrderNum() == undefined || data.SeqOrderNum() == null || data.SeqOrderNum() == " ") {
                $('#valErrorQR').text("Sequence Order Number cannot be left blank.");
                $('#valErrorQR').show();
            }
            else if (data.Response() == "" || data.Response() == undefined || data.Response() == null || data.Response() == " ") {
                $('#valErrorQR').text("Response entry cannot be left blank.");
                $('#valErrorQR').show();
            }

            else {
                $('#valErrorQR').text("");
                $('#valErrorQR').hide();
                Result = true;
            }
            return Result;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ValidateResponse() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function isInt(value) {
        return !isNaN(value) &&
            parseInt(Number(value)) == value &&
            !isNaN(parseInt(value, 10));
    }

    function OpenRiskQuestionOrderPopup() {
        try {
            $('#valQuestionError').hide();
            $('#RiskFactorReorderTableDiv').show();
            $('#RiskFactorReorderTable').show();
            $('#SaveQuestionSortButton').show();
            AMLQsViewModel.popUpTitle("Re-Order");
            AMLQsViewModel.addPopUpCss(true);
            $('#frmRiskQuestionReordermodel').modal('show');
            if (AMLQsViewModel.RiskAreaQuestionReorderList().length == 0) {
                $('#valQuestionError').show();
                $('#RiskFactorReorderTableDiv').hide();
                $('#RiskFactorReorderTable').hide();
                $('#SaveQuestionSortButton').hide();
                document.getElementById('valQuestionError').innerHTML = "No data is available.";
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskQuestionOrderPopup() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function OpenRiskAreaOrderPopup() {
        try {
            AMLQsViewModel.popUpTitle("Re-Order");
            AMLQsViewModel.addPopUpCss(true);
            $('#frmRiskAreaReordermodel').modal('show');

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaOrderPopup() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }


    function OpenQualRespSetupPopup() {
        try {
            $('#ResponseTypeError').hide();
            AMLQsViewModel.IsDeletedFlag(false);
            AMLQsViewModel.popUpTitle("Configure Response Types");
            AMLQsViewModel.addPopUpCss(true);
            if ($.fn.dataTable.isDataTable('#QualResponseTypeTable')) {
                $('#QualResponseTypeTable').DataTable({ retrieve: true }).destroy();
            }
            GetAllResponseTypes();
            $('#frmQualRespTypemodel').modal('show');

            $('#QualResponseTypeTable').DataTable({
                searching: false,
                ordering: false
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: OpenRiskAreaOrderPopup() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function DownFunctionalityRiskArea(data, event) {
        try {
            $('#valError').hide();
            for (var i = 0; i < AMLQsViewModel.RiskAreaReorderList().length; i++) {

                if (data.RiskAreaId() == AMLQsViewModel.RiskAreaReorderList()[i].RiskAreaId()) {
                    if (i == AMLQsViewModel.RiskAreaReorderList().length - 1) {
                        $('#valError').show();
                        document.getElementById('valError').innerHTML = "This cannot go further DOWN";
                    }
                    else {
                        var x = AMLQsViewModel.RiskAreaReorderList()[i].RiskAreaId();
                        var y = AMLQsViewModel.RiskAreaReorderList()[i].RiskAreaName();

                        AMLQsViewModel.RiskAreaReorderList()[i].RiskAreaId(AMLQsViewModel.RiskAreaReorderList()[i + 1].RiskAreaId());
                        AMLQsViewModel.RiskAreaReorderList()[i].RiskAreaName(AMLQsViewModel.RiskAreaReorderList()[i + 1].RiskAreaName());

                        AMLQsViewModel.RiskAreaReorderList()[i + 1].RiskAreaId(x);
                        AMLQsViewModel.RiskAreaReorderList()[i + 1].RiskAreaName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DownFunctionalityRiskArea() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function DownFunctionalityRiskSubArea(data, event) {
        try {
            $('#valreorderSubError').hide();
            for (var i = 0; i < AMLQsViewModel.RiskSubAreaReorderList().length; i++) {

                if (data.RiskAreaId() == AMLQsViewModel.RiskSubAreaReorderList()[i].RiskAreaId()) {
                    if (i == AMLQsViewModel.RiskSubAreaReorderList().length - 1) {
                        $('#valreorderSubError').show();
                        document.getElementById('valreorderSubError').innerHTML = "This cannot go further DOWN";
                    }
                    else {
                        var x = AMLQsViewModel.RiskSubAreaReorderList()[i].RiskAreaId();
                        var y = AMLQsViewModel.RiskSubAreaReorderList()[i].RiskAreaName();

                        AMLQsViewModel.RiskSubAreaReorderList()[i].RiskAreaId(AMLQsViewModel.RiskSubAreaReorderList()[i + 1].RiskAreaId());
                        AMLQsViewModel.RiskSubAreaReorderList()[i].RiskAreaName(AMLQsViewModel.RiskSubAreaReorderList()[i + 1].RiskAreaName());

                        AMLQsViewModel.RiskSubAreaReorderList()[i + 1].RiskAreaId(x);
                        AMLQsViewModel.RiskSubAreaReorderList()[i + 1].RiskAreaName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DownFunctionalityRiskSubArea() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }


    function UpFunctionalityRiskQuestion(data, event) {
        try {
            $('#valQuestionError').hide();
            for (var i = 0; i < AMLQsViewModel.RiskAreaQuestionReorderList().length; i++) {

                if (data.QuestionId() == AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionId()) {
                    if (i == 0) {
                        $('#valQuestionError').show();
                        document.getElementById('valQuestionError').innerHTML = "This cannot go further UP";
                    }
                    else {
                        var x = AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionId();
                        var y = AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionShortName();

                        AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionId(AMLQsViewModel.RiskAreaQuestionReorderList()[i - 1].QuestionId());
                        AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionShortName(AMLQsViewModel.RiskAreaQuestionReorderList()[i - 1].QuestionShortName());

                        AMLQsViewModel.RiskAreaQuestionReorderList()[i - 1].QuestionId(x);
                        AMLQsViewModel.RiskAreaQuestionReorderList()[i - 1].QuestionShortName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: DownFunctionalityRiskQuestion() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function DownFunctionalityRiskQuestion(data, event) {
        try {
            $('#valQuestionError').hide();
            for (var i = 0; i < AMLQsViewModel.RiskAreaQuestionReorderList().length; i++) {

                if (data.QuestionId() == AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionId()) {
                    if (i == AMLQsViewModel.RiskAreaQuestionReorderList().length - 1) {
                        $('#valQuestionError').show();
                        document.getElementById('valQuestionError').innerHTML = "This cannot go further Down";
                    }
                    else {
                        var x = AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionId();
                        var y = AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionShortName();

                        AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionId(AMLQsViewModel.RiskAreaQuestionReorderList()[i + 1].QuestionId());
                        AMLQsViewModel.RiskAreaQuestionReorderList()[i].QuestionShortName(AMLQsViewModel.RiskAreaQuestionReorderList()[i + 1].QuestionShortName());

                        AMLQsViewModel.RiskAreaQuestionReorderList()[i + 1].QuestionId(x);
                        AMLQsViewModel.RiskAreaQuestionReorderList()[i + 1].QuestionShortName(y);
                        break;
                    }
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: UpFunctionalityRiskArea() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function CancelRiskAreaQuestionSortOrder() {
        try {
            AMLQsViewModel.RiskAreaQuestionReorderList([]);
            var MappedRiskAreaSortMOdelDup = $.map(AMLQsViewModel.RiskAreaQuestionReorderListDup(), function (result) {
                return new QualitativeQuestionsSortOrderModelDup(result);
            });
            AMLQsViewModel.RiskAreaQuestionReorderList(MappedRiskAreaSortMOdelDup)
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelRiskAreaQuestionSortOrder() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
        }

    function CloseModel(model_id) {
        $(model_id).modal('hide');
    }


    function CancelResponseItem() {
        try {
            var status = "";
            if (AMLQsViewModel.IsDeletedFlag() === true) {
                status = updateResponseItem();
            }
            if (status !== false) {
                $('#frmQualRespTypemodel').modal('hide');
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: CancelResponseItem() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function SaveQuestionSortOrder() {
        try {

            var currentAreaId = AMLQsViewModel.CurrentSubRiskAreaId();
            var csrfToken = $("input[name='__RequestVerificationToken']").val();
            var headers = appsecurity.getSecurityHeaders();
            headers.__RequestVerificationToken = csrfToken;
            $.ajax({
                url: "/api/Configuration/SaveQualQuestionSortOrder?AreaId=" + currentAreaId,
                headers: headers,
                type: "POST",
                contentType: 'application/json',
                dataType: 'json',
                data: JSON.stringify($.map(AMLQsViewModel.RiskAreaQuestionReorderList(), function (item) {
                    return { QuestionId: item.QuestionId(), SortOrder: item.SortOrder };
                }))
            })
                .success(ajaxSuccessOverall)
                .fail(ajaxFailOverall);

            function ajaxSuccessOverall(jsonResult, status) {
                try {
                    if (jsonResult != null) {
                        if (jsonResult != 1) {
                            $('#frmRiskQuestionReordermodel').modal('hide');
                            $('body').removeClass('modal-open');
                            $('.modal-backdrop').remove();
                            GetAllQuestionsQualitative();
                            logger.logSuccess('Sort Order saved successfully.', 'Success', system.getModuleId(AMLQsViewModel), true);
                        }
                    }
                } catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxSuccess() method in savesortorder() method in Businessunit.js';
                    logger.logMessage(msg);
                }
            }
            function ajaxFailOverall(error, status) {
                try {
                    if (error.status == 401) {
                        app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                            .then(function (option) {
                                if (option == "OK")
                                    navigation.unauthorized();
                            })
                    }
                    else {
                        var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in savesortorder() method in AMLInherentWeightings.js';
                        logger.logMessage(msg);
                    }
                }
                catch (e) {
                    var msg = 'Exception: ' + e + ' | Source: ajaxFail() method in savesorterorder() method in AMLInherentWeightings.js';
                    logger.logMessage(msg);
                }
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: SaveSortOrder() method in BusinessUnit.js';
            logger.logMessage(msg);
        }
    }
    //-------------------------------------------------------Logic Related to Question's Response Ends Here---------------------------------------------------------------------------

    //---------------------------------------------------------Model Definition Starts Here--------------------------------------------------------------------------------------------

    function RiskAreaModel(item) {
        try {
            var self = this;

            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.hasSubArea = ko.observable(item.hasSubArea);
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
            self.TargetRow = ko.observable();
            self.AMLRank = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCRank = ko.observable($('<div/>').html(item.SANCRank).text());
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
            self.ZATIdList = ko.observable(item.ZATIdList);
            self.ZATNames = ko.observable(item.ZATNames);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function jsTreeModel(item) {
        var self = this;

        self.id = item.AreaLevelId.toString();
        self.text = item.AreaLevelName;
        if (AMLQsViewModel.AreaLeveljstree()[self.id].length > 0) {
            self.nodes = $.map(AMLQsViewModel.AreaLeveljstree()[self.id], function (result) {
                return new jsTreeModel(result);
            });
        }
        self.state = { expanded: false };
        self.dead_node = item.DeadNode;
        self.assessmentTypeList = ko.observableArray(item.AssessmentTypeList);
    }
    function RiskSubAreaModel(item) {
        try {
            var self = this;

            self.RiskAreaName = ko.observable($('<div/>').html(item.RiskAreaName).text());
            self.RiskAreaId = ko.observable(item.RiskAreaId);
            self.hasSubArea = ko.observable(item.hasSubArea);
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.RiskAreaType = ko.observable($('<div/>').html(item.RiskAreaType).text());
            self.RiskAreaNotes = ko.observable($('<div/>').html(item.RiskAreaNotes).text());
            self.TargetRow = ko.observable();
            self.AMLRank = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCRank = ko.observable($('<div/>').html(item.SANCRank).text());
            self.QualRiskSubAreaSubList = ko.observableArray(item.RiskAreaSubList);
            self.ParentRiskAreaId = ko.observable(item.ParentRiskAreaId);
            self.ZATIdList = ko.observable(item.ZATIdList);
            self.ZATNames = ko.observable(item.ZATNames);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskSubAreaModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function ResponseOptionModel(item) {
        try {
            var self = this;

            self.ResponseTypeId = ko.observable(item.ResponseTypeId);
            self.ResponseTypeName = ko.observable(item.ResponseTypeName);
            self.OptionTypeShortName = ko.observable(item.OptionTypeShortName);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskAreaModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function AssessmentModel(item) {
        try {
            var self = this;
            if (isNaN(item)) {
                self.ID = item.ID
            }
            else {
                self.ID = item;
            }

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorSortOrderDupModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function QualitativeQuestionsSortOrderModel(item) {
        var self = this;
        self.QuestionId = ko.observable(item.QuestionId);
        self.QuestionShortName = ko.observable($('<div/>').html(item.QuestionShortName).text());
        self.SortOrder = AMLQsViewModel.RiskQuestionSortOrder() + 1
        AMLQsViewModel.RiskQuestionSortOrder(AMLQsViewModel.RiskQuestionSortOrder() + 1);
    }
    function QualitativeQuestionsModel(item) {
        try {

            var self = this;
            self.QuestionId = ko.observable(item.QuestionId);
            self.AMLRank = ko.observable($('<div/>').html(item.AMLRank).text());
            self.SANCRank = ko.observable($('<div/>').html(item.SANCRank).text());
            self.QuestionShortName = ko.observable($('<div/>').html(item.QuestionShortName).text());
            self.QuestionName = ko.observable($('<div/>').html(item.QuestionName).text());
            self.QuestionType = ko.observable($('<div/>').html(item.QuestionType).text());
            self.CalculationApplicability = ko.observable(item.CalculationApplicability);
            self.MultiselectQuestion = ko.observable(item.MultiselectQuestion);
            self.HeaderUID = ko.observable(item.HeaderUID);
            self.CopyOverAreas = ko.observable(item.CopyOverAreas);
            self.CopyOverAreasNames = ko.observable(item.CopyOverAreasNames);
            if (item.AssessmentIdList != undefined && item.AssessmentIdList != null) {
                var MappedAssessments = $.map(item.AssessmentIdList, function (result) {
                    return new AssessmentModel(result);
                });
            }
            self.MappedAssessmentType = ko.observableArray(MappedAssessments);
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
            self.ResponseType = ko.observable($('<div/>').html(item.ResponseType).text());
            self.MappedResponseType = ko.observableArray(item.ResponseIdList);
            self.Applicable = ko.observable(item.Applicable);
            self.RiskAreaId = ko.observable();
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
            self.FactorType = ko.observable($('<div/>').html(item.FactorType).text());
            self.ParentQuestionText = ko.observable($('<div/>').html(item.ParentQuestionText).text());
            self.ReadOnlyTypeFactor = ko.observable(item.ReadOnlyTypeFactor);
            self.HeaderTypeFactor = ko.observable(item.HeaderTypeFactor);
            self.ConditionalTypeFactor = ko.observable(item.ConditionalTypeFactor);
            self.ParentQuestionId = ko.observable(item.ParentQuestionId);
            self.ParentResponseId = ko.observable(item.ParentResponseId);
            self.QuestionGuideline = ko.observable(item.QuestionGuideline);
            self.OptionTypeShortName = ko.observable(item.OptionTypeShortName);
            self.ResponseOptionTypeList = $.map(item.ResponseOptionTypeModelObject, function (result) {
                return new ResponseOptionModel(result);
            });

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualitativeQuestionsModel() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function QualitativeQuestionsSortOrderModelDup(item) {
        try {
            var self = this;
            self.QuestionId = ko.observable(item.QuestionId());
            self.QuestionShortName = ko.observable(item.QuestionShortName());
            self.SortOrder = (item.SortOrder);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualitativeQuestionsSortOrderModelDup() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function QuestionResponseModel(item) {
        try {
            var self = this;
            self.ResponseId = ko.observable(item.ResponseId);
            self.QuestionId = ko.observable(item.QuestionId);
            self.Response = ko.observable($('<div/>').html(item.Response).text());
            self.RiskLevelId = ko.observable(item.RiskLevelId);
            self.RiskLevel = ko.observable($('<div/>').html(item.RiskLevel).text());
            self.AssessmentType = ko.observable($('<div/>').html(item.AssessmentType).text());
            self.RiskMapping = ko.observable($('<div/>').html(item.RiskMapping).text())
            self.ResponseType = ko.observable($('<div/>').html(item.ResponseType).text())
            self.SeqOrderNum = ko.observable(item.SeqOrderNum);
            self.RiskAreaSubList = ko.observableArray(item.RiskAreaSubList);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QualitativeQuestionsModel() method in AMLQualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function AssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId).text());
            self.AssessmentName = ko.observable(item.AssessmentName);
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName).text());
            self.Description = ko.observable($('<div/>').html(item.Description).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: AssessmentListModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function FilteredAssessmentListModel(item) {
        try {
            var self = this;
            self.AssessmentId = ko.observable($('<div/>').html(item.AssessmentId()).text());
            self.AssessmentName = ko.observable(item.AssessmentName());
            self.AssessmentDisplayName = ko.observable($('<div/>').html(item.AssessmentDisplayName()).text());
            self.Description = ko.observable($('<div/>').html(item.Description()).text());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: FilteredAssessmentListModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function RiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelName = item.RiskLevelName;
            self.RiskLevelShortText = item.RiskLevelShortText;
            self.ScoringType = item.ScoringType;
            self.LevelCount = item.RiskLevelCount;
            self.AssessmentTypeId = item.AssessmentId;
            self.isQuantitative = item.isQuantitative;
            self.MappedRiskLevels = $.map(item.RiskLevelDetailsModel, function (result) {
                return new InherentRiskLevelModel(result);
            });
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskLevelModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function InherentRiskLevelModel(item) {
        try {
            var self = this;
            self.RiskLevelId = item.RiskLevelId;
            self.RiskLevelParentId = item.RiskLevelParentId;
            self.RiskLevelcss = item.RiskLevelcss;
            self.RiskLevelComents = item.RiskLevelComents;
            self.RiskLevelDescription = item.RiskLevel + ' - ' + item.RiskLevelDescription;
            self.RiskLevel = item.RiskLevel;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: InherentRiskLevelModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    //---------------------------------------------------------Model Definition Ends Here--------------------------------------------------------------------------------------------

    function GetLanguageName(languageId) {
        if (AMLQsViewModel.ObjGeneralSettings.LanguageList().length == 0) {
            AMLQsViewModel.ObjGeneralSettings.getLanguages();
        }
        for (var i = 0; i < AMLQsViewModel.ObjGeneralSettings.LanguageList().length; i++) {
            if (AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGE_ID().toString() === languageId)
                return AMLQsViewModel.ObjGeneralSettings.LanguageList()[i].LANGUAGENAME();
        }
        return ""; // The object was not found
    }


    function QuestionTypeChangedFactor(data, event) {
        try {
            //Toggle the factor type flags
            document.getElementById(event.currentTarget.id).checked = true;
            if (event.currentTarget.value == "ReadOnlyTypeFactor") {
                AMLQsViewModel.FactorReadOnlyType(true);
                AMLQsViewModel.FactorHeaderType(false);
                AMLQsViewModel.FactorConditionalType(false);
                document.getElementById("ReadOnlyTypeFactor").checked = true;
                document.getElementById("HeaderTypeFactor").checked = false;
                document.getElementById("ConditionalTypeFactor").checked = false;
                $('#FactorRespTypeID').multiselect();
            }
            else if (event.currentTarget.value == "HeaderTypeFactor") {
                AMLQsViewModel.FactorReadOnlyType(false);
                AMLQsViewModel.FactorHeaderType(true);
                AMLQsViewModel.FactorConditionalType(false);
                document.getElementById("ReadOnlyTypeFactor").checked = false;
                document.getElementById("HeaderTypeFactor").checked = true;
                document.getElementById("ConditionalTypeFactor").checked = false;
            }
            else if (event.currentTarget.value == "ConditionalTypeFactor") {
                AMLQsViewModel.FactorReadOnlyType(false);
                AMLQsViewModel.FactorHeaderType(false);
                AMLQsViewModel.FactorConditionalType(true);
                document.getElementById("ReadOnlyTypeFactor").checked = false;
                document.getElementById("HeaderTypeFactor").checked = false;
                document.getElementById("ConditionalTypeFactor").checked = true;
                $('#FactorRespTypeID').multiselect();
                PopulateParentQuestionAndResponseDropdowns();
                $("#frmQualitativeQuestionsScroll").css({ "height": "auto", "max-height": "auto", "overflow-y": "auto", "overflow-x": "hidden" });

                $("#ParentResponseDropDown").multiselect();

            }
            else {
                AMLQsViewModel.FactorReadOnlyType(false);
                AMLQsViewModel.FactorHeaderType(false);
                AMLQsViewModel.FactorConditionalType(false);
            }
            return true;

        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: QuestionTypeChangedFactor() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function PopulateParentQuestionAndResponseDropdowns() {
        try {

            if (AMLQsViewModel.ParentFactorList().length == 0) {
                GetAllQuestionsQualitative();
            }
            $("#ParentQuestionLabel").html($("#ParentQuestionDropDown :selected").text());

            if ($('#ParentQuestionDropDown').text() != "" && $('#ParentQuestionDropDown').text() != undefined) {
                ParentQuestionChanged();
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: PopulateParentQuestionAndResponseDropdowns() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    //Parent question dropdown change event
    function ParentQuestionChanged() {
        try {
            $("#ParentQuestionLabel").html($("#ParentQuestionDropDown :selected").text());

            var value = parseInt($('#ParentQuestionDropDown').val());
            GetQuestionResponseConditional(parseInt(value));
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ParentQuestionChanged() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function EditParentQuestionChanged(ParentQuestionId) {
        try {
            GetQuestionResponseConditional(ParentQuestionId);
            $("#ParentResponseDropDown").val(AMLQsViewModel.ParentResponseId());
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ParentQuestionChanged() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function GetQuestionResponseConditional(data_QUID) {
        try {
            var CurrentAreaId = parseInt(AMLQsViewModel.CurrentSubRiskAreaId());
            return $.ajax({
                url: "/api/Qualitative/GetQuestionResponseConditional",
                type: "GET",
                headers: appsecurity.getSecurityHeaders(),
                data: {
                    "QuestionId": data_QUID,
                    "SurveyCategoryID": AMLQsViewModel.InherentSetupQualObj().data.SurveyCategoryId(),
                    "AssessmentTypes": AMLQsViewModel.InherentSetupQualObj().data.AssessmentTypeId(),
                    "CurrentAreaId": CurrentAreaId
                }
            })
                .success(ajaxSuccess)
                .fail(ajaxFail);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ajax call in GetQuestionResponseConditional() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }

        function ajaxSuccess(jsonResult, error) {
            try {
                AMLQsViewModel.QuestionResponsesList([]);
                if (jsonResult != null && jsonResult.length > 0) {
                    AMLQsViewModel.ParentFactorResponseList([]);

                    var mappedFirstList = $.map(jsonResult, function (result) {
                        return new ResponseFactorDropdownModel(result);
                    });
                    AMLQsViewModel.ParentFactorResponseList(mappedFirstList);
                    //for edit pop pup response dropdown default selection
                    if (AMLQsViewModel.EditFactorVisible() == true && AMLQsViewModel.ParentResponseId() != undefined && AMLQsViewModel.ParentResponseId() != 0) {
                        $("#ParentResponseDropDown").val(AMLQsViewModel.ParentResponseId());
                    }
                    $("#ParentResponseDropDown").multiselect('refresh');
                }
                else if (jsonResult != null && jsonResult.length == 0) {
                    AMLQsViewModel.ParentFactorResponseList([]);
                    $("#ParentResponseDropDown").multiselect('refresh');
                }
                else if (jsonResult == null)
                    logger.logError('An error occurred while fetching the Responses for this Question.', 'Error', system.getModuleId(AMLQsViewModel), true);
            }
            catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxSuccess in GetQuestionResponseConditional() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        }

        function ajaxFail(error, status) {
            try {
                if (error.status == 401) {
                    app.showMessage(((!AMLQsViewModel.LocaleCheckFlag() || AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage') == -1) ? 'You have been logged out. Please login again to complete the operation.' : AMLQsViewModel.ObjGeneralSettings.LocalizedTextList()[AMLQsViewModel.ObjGeneralSettings.LocalizedIndexList.indexOf('LoggedOutMessage')].Name), "Error in Edit Operation", ["OK"], false, { buttonClass: "fa fa-times btn btn-default", primaryButtonClass: "fa fa-check btn btn-success autofocus", secondaryButtonClass: "", "class": "modal-content messageBox", style: null, popupIcon: 'title-icon col-md-1 fa fa-login' })
                        .then(function (option) {
                            if (option == "OK")
                                navigation.unauthorized();
                        })
                }
                else {
                    var msg = 'Exception: ' + error.statusText + ' | Source: ajaxFail in GetQuestionResponseConditional() method in QualitativeSetup.js';
                    logger.logMessage(msg);
                }
            } catch (e) {
                var msg = 'Exception: ' + e + ' | Source: ajaxFail in GetQuestionResponseConditional() method in QualitativeSetup.js';
                logger.logMessage(msg);
            }
        };
    }

    function ResponseFactorDropdownModel(item) {
        try {
            var self = this;
            var Mappeditems = $.map(item, function (result) {
                return new ResponseChildDropdownModel(result);
            });

            self.MappedResponseList = Mappeditems;
            if (Mappeditems.length > 0) {
                self.ResponseType = Mappeditems[0].ResponseType;
            } else {
                self.ResponseType = "";
            }
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResponseFactorDropdownModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function ResponseChildDropdownModel(item) {
        try {
            var self = this;
            self.ResponseId = item.ResponseId;
            self.Response = item.Response;
            self.ResponseType = item.ResponseType;
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ResponseChildDropdownModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

    function ZATRATModel(ZATID, ZATNAME, RATID, ZATSHORTNAME) {
        try {
            var self = this;
            self.ZAT_UID = ko.observable(ZATID);
            self.ZATName = ko.observable(ZATNAME);
            self.RAT_UID = ko.observable(RATID);
            self.ZATShortName = ko.observable(ZATSHORTNAME);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: ZATRATModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }
    function RiskFactorHeaderModel(item) {
        try {
            var self = this;
            self.HeaderSubFactorId = ko.observable(item.HeaderSubFactorId);
            self.HeaderSubFactorName = ko.observable(item.HeaderSubFactorName);
            self.ApplicableRATId = ko.observable(item.ApplicableRATId);
            self.ApplicableRATNames = ko.observable(item.ApplicableRATIdNames);
            self.ApplicableAreaIds = ko.observable(item.ApplicableAreaIds);
        }
        catch (e) {
            var msg = 'Exception: ' + e + ' | Source: RiskFactorHeaderModel() method in QualitativeSetup.js';
            logger.logMessage(msg);
        }
    }

});


